import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import CookieBanner from '../CookieBanner';

const APP_URL = process.env.REACT_APP_APP_URL;

export default function Landing() {
  const { isAuthenticated, loading } = useAuth();

  useEffect(() => {
    if (!loading && isAuthenticated && APP_URL) {
      window.location.href = `${APP_URL}/dashboard`;
    }
  }, [loading, isAuthenticated]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">

      {/* ===== ЗАГЛУШКА НА ВЕСЬ ЭКРАН ===== */}
      <section className="min-h-screen flex flex-col items-center justify-center px-4 relative">
        {/* Логотип сверху */}
        <div className="absolute top-6 left-0 right-0">
          <div className="max-w-6xl mx-auto px-4 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2 text-xl font-bold text-blue-600">
              <span className="w-2 h-2 rounded-full bg-blue-600 inline-block" />
              MAILORA
            </Link>
            <div className="flex gap-3">
              <Link
                to="/login"
                className="px-4 py-2 rounded-xl text-gray-700 hover:bg-gray-100 transition"
              >
                Войти
              </Link>
              <Link
                to="/register"
                className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition shadow-md"
              >
                Регистрация
              </Link>
            </div>
          </div>
        </div>

        {/* Центральный контент */}
        <div className="max-w-3xl text-center">
          <span className="inline-block text-xs font-semibold tracking-wider uppercase text-blue-600 bg-blue-50 px-3 py-1 rounded-full mb-6">
            Мы запустились!
          </span>
          <h1 className="text-4xl md:text-6xl font-bold leading-tight">
            Сервис для email рассылок
          </h1>
          <p className="mt-6 text-lg md:text-xl text-gray-600 max-w-[56ch] mx-auto">
            Привлекайте новых клиентов в B2B сегменте с помощью деловой коммуникации через email переписки.
          </p>
          <div className="flex gap-3 flex-wrap justify-center mt-10">
            <Link
              to="/register"
              className="px-6 py-3 rounded-xl bg-blue-600 text-white font-medium hover:bg-blue-700 transition shadow-md"
            >
              Попробовать бесплатно 7 дней
            </Link>
          </div>
        </div>

        {/* Стрелка вниз (намёк на скролл) */}
        <div className="absolute bottom-8 left-0 right-0 flex justify-center text-gray-400 animate-bounce motion-reduce:animate-none">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 5v14M19 12l-7 7-7-7" />
          </svg>
        </div>
      </section>

      {/* ===== ФУТЕР — ТОЛЬКО РЕКВИЗИТЫ И КОПИРАЙТ ===== */}
      <footer id="footer" className="bg-white border-t border-gray-200 py-10">
        <div className="max-w-6xl mx-auto px-4">

          {/* Реквизиты — тонкое начертание */}
          <div className="text-[13px] leading-relaxed text-gray-500 font-light">
            <div className="flex flex-wrap gap-x-6 gap-y-1">
              <span>
                <span className="text-gray-400">ИП</span> Сидоренко Руслан Владимирович
              </span>
              <span>
                <span className="text-gray-400">ИНН</span> 611300126009
              </span>
              <span>
                <span className="text-gray-400">ОГРНИП</span> 317619600088799
              </span>
            </div>
          </div>

          {/* Копирайт */}
          <div className="border-t border-gray-200 mt-6 pt-6 text-[13px] text-gray-500 font-light">
            © {new Date().getFullYear()} Mailora. Все права защищены.
          </div>

        </div>
      </footer>

      <CookieBanner />
    </div>
  );
}

// // // // import React, { useEffect, useRef, useState } from 'react';
// // // // import { Link } from 'react-router-dom';
// // // // import { useAuth } from '../AuthContext';
// // // // import CookieBanner from '../CookieBanner';

// // // // const APP_URL = process.env.REACT_APP_APP_URL;

// // // // const TOTAL = 500; // сколько писем «отправляем» в сцене
// // // // const NAMES = ['ivanov', 'a.smirnova', 'director', 'sales', 'p.kuznetsov', 'info', 'm.orlova', 'ceo', 'zakupki', 'k.belov', 'hr', 'o.volkova'];
// // // // const DOMAINS = ['stroytech.ru', 'logist-pro.ru', 'agroholding.ru', 'medline.ru', 'promsnab.ru', 'it-partner.ru', 'retail-group.ru', 'energo.ru'];

// // // // const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
// // // // const lerp = (a, b, t) => a + (b - a) * t;
// // // // const seg = (p, a, b) => clamp((p - a) / (b - a));
// // // // const easeOut = (t) => 1 - Math.pow(1 - t, 3);
// // // // const mail = (i) => `${NAMES[i % NAMES.length]}@${DOMAINS[(i * 7) % DOMAINS.length]}`;

// // // // /* ---------- Matrix: дождь из 1 и 0 на canvas ---------- */
// // // // function BinaryRain({ pRef }) {
// // // //   const ref = useRef(null);
// // // //   useEffect(() => {
// // // //     const c = ref.current;
// // // //     const ctx = c.getContext('2d');
// // // //     const W = 640, H = 400, size = 14;
// // // //     c.width = W; c.height = H;
// // // //     const cols = Math.floor(W / size);
// // // //     const drops = Array.from({ length: cols }, () => Math.random() * -40);
// // // //     let raf, last = 0;
// // // //     const draw = (t) => {
// // // //       raf = requestAnimationFrame(draw);
// // // //       if (t - last < 45) return;
// // // //       last = t;
// // // //       const p = pRef.current;
// // // //       const power = seg(p, 0.12, 0.45); // с какого момента «оживает»
// // // //       ctx.fillStyle = 'rgba(2, 8, 20, 0.16)';
// // // //       ctx.fillRect(0, 0, W, H);
// // // //       ctx.font = `${size}px ui-monospace, Menlo, monospace`;
// // // //       const active = Math.floor(cols * (0.15 + 0.85 * power));
// // // //       for (let i = 0; i < active; i++) {
// // // //         const x = i * size;
// // // //         const y = drops[i] * size;
// // // //         ctx.fillStyle = '#e8f1ff';
// // // //         ctx.fillText(Math.random() > 0.5 ? '1' : '0', x, y);
// // // //         ctx.fillStyle = `rgba(59, 130, 246, ${0.35 + 0.5 * power})`;
// // // //         ctx.fillText(Math.random() > 0.5 ? '1' : '0', x, y - size);
// // // //         drops[i] += 0.6 + power * 1.2;
// // // //         if (y > H && Math.random() > 0.96) drops[i] = Math.random() * -10;
// // // //       }
// // // //     };
// // // //     raf = requestAnimationFrame(draw);
// // // //     return () => cancelAnimationFrame(raf);
// // // //   }, [pRef]);
// // // //   return <canvas ref={ref} className="absolute inset-0 w-full h-full" aria-hidden="true" />;
// // // // }

// // // // /* ---------- MacBook ---------- */
// // // // function MacBook({ p, pRef }) {
// // // //   const sent = Math.round(easeOut(seg(p, 0.32, 0.88)) * TOTAL);
// // // //   const panel = seg(p, 0.28, 0.4);
// // // //   const delivered = Math.round(sent * 0.98);
// // // //   const opened = Math.round(sent * 0.46);
// // // //   const replies = Math.round(sent * 0.07);
// // // //   const log = Array.from({ length: 6 }, (_, k) => sent - k).filter((n) => n > 0);

// // // //   return (
// // // //     <div className="w-[min(90vw,920px)] mx-auto select-none">
// // // //       {/* крышка */}
// // // //       <div
// // // //         className="relative rounded-[22px] p-[10px] shadow-[0_40px_120px_-20px_rgba(37,99,235,0.55)]"
// // // //         style={{ background: 'linear-gradient(160deg,#2b2f38,#0d0f14)', border: '1px solid #3a3f4b' }}
// // // //       >
// // // //         <div className="relative rounded-[12px] overflow-hidden bg-[#020814]" style={{ aspectRatio: '16 / 10' }}>
// // // //           <BinaryRain pRef={pRef} />
// // // //           {/* вырез камеры */}
// // // //           <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[14%] h-[4%] bg-black rounded-b-lg z-20" />

// // // //           {/* стартовая строка */}
// // // //           <div
// // // //             className="absolute inset-0 flex items-center justify-center font-mono text-blue-300 text-sm md:text-lg z-10"
// // // //             style={{ opacity: 1 - seg(p, 0.14, 0.3) }}
// // // //           >
// // // //             <span>&gt; mailora --send campaign_b2b</span>
// // // //             <span className="ml-1 w-2 h-5 bg-blue-300 animate-pulse" />
// // // //           </div>

// // // //           {/* окно рассылки */}
// // // //           <div
// // // //             className="absolute inset-[7%] rounded-xl bg-[#0a1226]/85 backdrop-blur-md border border-blue-400/25 p-3 md:p-5 text-white z-10 flex flex-col"
// // // //             style={{ opacity: panel, transform: `translateY(${(1 - panel) * 24}px)` }}
// // // //           >
// // // //             <div className="flex items-center gap-1.5 mb-3">
// // // //               <span className="w-2.5 h-2.5 rounded-full bg-red-400" />
// // // //               <span className="w-2.5 h-2.5 rounded-full bg-yellow-400" />
// // // //               <span className="w-2.5 h-2.5 rounded-full bg-green-400" />
// // // //               <span className="ml-3 text-[11px] md:text-xs text-blue-200/70">Кампания «Новые клиенты Q4»</span>
// // // //             </div>
// // // //             <div className="flex items-end justify-between">
// // // //               <div>
// // // //                 <div className="text-3xl md:text-5xl font-bold tabular-nums leading-none">{sent}</div>
// // // //                 <div className="text-[11px] md:text-xs text-blue-200/70 mt-1">писем отправлено из {TOTAL}</div>
// // // //               </div>
// // // //               <div className="hidden sm:flex gap-5 text-right text-[11px] md:text-xs text-blue-200/70">
// // // //                 <div><div className="text-base md:text-lg text-white tabular-nums">{delivered}</div>доставлено</div>
// // // //                 <div><div className="text-base md:text-lg text-white tabular-nums">{opened}</div>открыто</div>
// // // //                 <div><div className="text-base md:text-lg text-emerald-300 tabular-nums">{replies}</div>ответов</div>
// // // //               </div>
// // // //             </div>
// // // //             <div className="h-1.5 rounded-full bg-white/10 mt-3 overflow-hidden">
// // // //               <div className="h-full bg-blue-500" style={{ width: `${(sent / TOTAL) * 100}%` }} />
// // // //             </div>
// // // //             <ul className="mt-3 space-y-1 font-mono text-[10px] md:text-xs overflow-hidden">
// // // //               {log.map((n) => (
// // // //                 <li key={n} className="flex justify-between text-blue-100/80">
// // // //                   <span className="truncate">{mail(n)}</span>
// // // //                   <span className="text-emerald-300 ml-3 shrink-0">отправлено</span>
// // // //                 </li>
// // // //               ))}
// // // //             </ul>
// // // //           </div>
// // // //         </div>
// // // //       </div>
// // // //       {/* основание */}
// // // //       <div
// // // //         className="mx-auto h-[14px] rounded-b-[18px] w-[112%] -ml-[6%] relative"
// // // //         style={{ background: 'linear-gradient(#c9ccd3,#8b8f98)', boxShadow: '0 20px 40px rgba(0,0,0,.5)' }}
// // // //       >
// // // //         <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[16%] h-[5px] rounded-b-md bg-[#6b6f78]" />
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // }

// // // // /* ---------- Страница ---------- */
// // // // export default function Landing() {
// // // //   const { isAuthenticated, loading } = useAuth();
// // // //   const sceneRef = useRef(null);
// // // //   const pRef = useRef(0);
// // // //   const [p, setP] = useState(0);

// // // //   useEffect(() => {
// // // //     if (!loading && isAuthenticated && APP_URL) {
// // // //       window.location.href = `${APP_URL}/dashboard`;
// // // //     }
// // // //   }, [loading, isAuthenticated]);

// // // //   useEffect(() => {
// // // //     if (loading) return;
// // // //     let raf = 0;
// // // //     const update = () => {
// // // //       raf = 0;
// // // //       const el = sceneRef.current;
// // // //       if (!el) return;
// // // //       const r = el.getBoundingClientRect();
// // // //       const v = clamp(-r.top / (r.height - window.innerHeight));
// // // //       pRef.current = v;
// // // //       setP(v);
// // // //     };
// // // //     const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
// // // //     update();
// // // //     window.addEventListener('scroll', onScroll, { passive: true });
// // // //     window.addEventListener('resize', onScroll);
// // // //     return () => {
// // // //       window.removeEventListener('scroll', onScroll);
// // // //       window.removeEventListener('resize', onScroll);
// // // //       if (raf) cancelAnimationFrame(raf);
// // // //     };
// // // //   }, [loading]);

// // // //   if (loading) {
// // // //     return (
// // // //       <div className="min-h-screen flex items-center justify-center bg-gray-50">
// // // //         <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
// // // //       </div>
// // // //     );
// // // //   }

// // // //   // Параллакс и зум ноутбука
// // // //   const zoom = easeOut(seg(p, 0.05, 0.5));
// // // //   const tilt = lerp(28, 0, easeOut(seg(p, 0, 0.35)));
// // // //   const scale = lerp(0.72, 1.12, zoom);
// // // //   const y = lerp(120, 30, easeOut(seg(p, 0, 0.3)));
// // // //   const heroOpacity = 1 - seg(p, 0.02, 0.18);
// // // //   const cap2 = seg(p, 0.2, 0.32) * (1 - seg(p, 0.5, 0.6));
// // // //   const cap3 = seg(p, 0.7, 0.85);

// // // //   return (
// // // //     <div className="min-h-screen bg-[#020814] text-white">
// // // //       {/* Шапка */}
// // // //       <header className="fixed top-0 inset-x-0 z-50">
// // // //         <div className="max-w-6xl mx-auto px-4 py-5 flex items-center justify-between">
// // // //           <Link to="/" className="flex items-center gap-2 text-xl font-bold text-blue-400">
// // // //             <span className="w-2 h-2 rounded-full bg-blue-400 inline-block" />
// // // //             MAILORA
// // // //           </Link>
// // // //           <div className="flex gap-3">
// // // //             <Link to="/login" className="px-4 py-2 rounded-xl text-blue-100 hover:bg-white/10 transition">
// // // //               Войти
// // // //             </Link>
// // // //             <Link to="/register" className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-500 transition shadow-md">
// // // //               Регистрация
// // // //             </Link>
// // // //           </div>
// // // //         </div>
// // // //       </header>

// // // //       {/* Сцена со скроллом: 450vh высоты, внутри — «липкий» экран */}
// // // //       <section ref={sceneRef} className="relative" style={{ height: '450vh' }}>
// // // //         <div className="sticky top-0 h-screen overflow-hidden">
// // // //           {/* слои фона с разной скоростью */}
// // // //           <div
// // // //             className="absolute -left-40 top-10 w-[520px] h-[520px] rounded-full bg-blue-600/25 blur-[120px]"
// // // //             style={{ transform: `translateY(${p * -260}px)` }}
// // // //           />
// // // //           <div
// // // //             className="absolute -right-32 bottom-0 w-[460px] h-[460px] rounded-full bg-indigo-500/20 blur-[120px]"
// // // //             style={{ transform: `translateY(${p * 320}px)` }}
// // // //           />

// // // //           {/* заголовок первого экрана */}
// // // //           <div
// // // //             className="absolute inset-x-0 top-[13vh] px-4 text-center z-10"
// // // //             style={{ opacity: heroOpacity, transform: `translateY(${p * -160}px)` }}
// // // //           >
// // // //             <span className="inline-block text-xs font-semibold tracking-wider uppercase text-blue-300 bg-blue-500/15 px-3 py-1 rounded-full mb-5">
// // // //               Мы запустились!
// // // //             </span>
// // // //             <h1 className="text-4xl md:text-6xl font-bold leading-tight">Сервис для email рассылок</h1>
// // // //             <p className="mt-4 text-base md:text-lg text-blue-100/70 max-w-[56ch] mx-auto">
// // // //               Привлекайте новых клиентов в B2B сегменте с помощью деловой коммуникации через email переписки.
// // // //             </p>
// // // //             <Link
// // // //               to="/register"
// // // //               className="inline-block mt-7 px-6 py-3 rounded-xl bg-blue-600 text-white font-medium hover:bg-blue-500 transition shadow-lg"
// // // //             >
// // // //               Попробовать бесплатно 7 дней
// // // //             </Link>
// // // //           </div>

// // // //           {/* подписи по ходу скролла */}
// // // //           <div
// // // //             className="absolute inset-x-0 top-[10vh] text-center px-4 z-10 pointer-events-none"
// // // //             style={{ opacity: cap2 }}
// // // //           >
// // // //             <h2 className="text-2xl md:text-4xl font-bold">Одно нажатие — и код оживает</h2>
// // // //           </div>
// // // //           <div
// // // //             className="absolute inset-x-0 top-[10vh] text-center px-4 z-10"
// // // //             style={{ opacity: cap3 }}
// // // //           >
// // // //             <h2 className="text-2xl md:text-4xl font-bold">Сотни писем ушли, пока вы пили кофе</h2>
// // // //             <Link
// // // //               to="/register"
// // // //               className="inline-block mt-5 px-6 py-3 rounded-xl bg-blue-600 text-white font-medium hover:bg-blue-500 transition shadow-lg"
// // // //             >
// // // //               Попробовать бесплатно 7 дней
// // // //             </Link>
// // // //           </div>

// // // //           {/* MacBook */}
// // // //           <div
// // // //             className="absolute inset-x-0 bottom-[6vh] z-0"
// // // //             style={{
// // // //               transform: `translateY(${y}px)`,
// // // //               perspective: '1600px',
// // // //             }}
// // // //           >
// // // //             <div style={{ transform: `rotateX(${tilt}deg) scale(${scale})`, transformOrigin: '50% 100%' }}>
// // // //               <MacBook p={p} pRef={pRef} />
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       </section>

// // // //       {/* Футер */}
// // // //       <footer id="footer" className="bg-white text-gray-900 border-t border-gray-200 py-10">
// // // //         <div className="max-w-6xl mx-auto px-4">
// // // //           <div className="text-[13px] leading-relaxed text-gray-500 font-light">
// // // //             <div className="flex flex-wrap gap-x-6 gap-y-1">
// // // //               <span><span className="text-gray-400">ИП</span> Сидоренко Руслан Владимирович</span>
// // // //               <span><span className="text-gray-400">ИНН</span> 611300126009</span>
// // // //               <span><span className="text-gray-400">ОГРНИП</span> 317619600088799</span>
// // // //             </div>
// // // //           </div>
// // // //           <div className="border-t border-gray-200 mt-6 pt-6 text-[13px] text-gray-500 font-light">
// // // //             © {new Date().getFullYear()} Mailora. Все права защищены.
// // // //           </div>
// // // //         </div>
// // // //       </footer>

// // // //       <CookieBanner />
// // // //     </div>
// // // //   );
// // // // }

// // // import React, { useEffect, useRef, useState } from 'react';
// // // import { Link } from 'react-router-dom';
// // // import { useAuth } from '../AuthContext';
// // // import CookieBanner from '../CookieBanner';

// // // const APP_URL = process.env.REACT_APP_APP_URL;

// // // const TOTAL = 500; // сколько писем «отправляем» в сцене
// // // const NAMES = ['ivanov', 'a.smirnova', 'director', 'sales', 'p.kuznetsov', 'info', 'm.orlova', 'ceo', 'zakupki', 'k.belov', 'hr', 'o.volkova'];
// // // const DOMAINS = ['stroytech.ru', 'logist-pro.ru', 'agroholding.ru', 'medline.ru', 'promsnab.ru', 'it-partner.ru', 'retail-group.ru', 'energo.ru'];

// // // const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
// // // const lerp = (a, b, t) => a + (b - a) * t;
// // // const seg = (p, a, b) => clamp((p - a) / (b - a));
// // // const easeOut = (t) => 1 - Math.pow(1 - t, 3);
// // // const mail = (i) => `${NAMES[i % NAMES.length]}@${DOMAINS[(i * 7) % DOMAINS.length]}`;

// // // /* ---------- Matrix: дождь из 1 и 0 на canvas ---------- */
// // // function BinaryRain({ pRef }) {
// // //   const ref = useRef(null);
// // //   useEffect(() => {
// // //     const c = ref.current;
// // //     const ctx = c.getContext('2d');
// // //     const W = 640, H = 400, size = 14;
// // //     c.width = W; c.height = H;
// // //     const cols = Math.floor(W / size);
// // //     const drops = Array.from({ length: cols }, () => Math.random() * -40);
// // //     let raf, last = 0;
// // //     const draw = (t) => {
// // //       raf = requestAnimationFrame(draw);
// // //       if (t - last < 45) return;
// // //       last = t;
// // //       const p = pRef.current;
// // //       const power = seg(p, 0.08, 0.4); // с какого момента «оживает»
// // //       ctx.fillStyle = 'rgba(2, 8, 20, 0.16)';
// // //       ctx.fillRect(0, 0, W, H);
// // //       ctx.font = `${size}px ui-monospace, Menlo, monospace`;
// // //       const active = Math.floor(cols * (0.15 + 0.85 * power));
// // //       for (let i = 0; i < active; i++) {
// // //         const x = i * size;
// // //         const y = drops[i] * size;
// // //         ctx.fillStyle = '#e8f1ff';
// // //         ctx.fillText(Math.random() > 0.5 ? '1' : '0', x, y);
// // //         ctx.fillStyle = `rgba(59, 130, 246, ${0.35 + 0.5 * power})`;
// // //         ctx.fillText(Math.random() > 0.5 ? '1' : '0', x, y - size);
// // //         drops[i] += 0.6 + power * 1.2;
// // //         if (y > H && Math.random() > 0.96) drops[i] = Math.random() * -10;
// // //       }
// // //     };
// // //     raf = requestAnimationFrame(draw);
// // //     return () => cancelAnimationFrame(raf);
// // //   }, [pRef]);
// // //   return <canvas ref={ref} className="absolute inset-0 w-full h-full" aria-hidden="true" />;
// // // }

// // // /* ---------- MacBook ---------- */
// // // function MacBook({ p, pRef }) {
// // //   const sent = Math.round(easeOut(seg(p, 0.24, 0.9)) * TOTAL);
// // //   const panel = seg(p, 0.2, 0.3);
// // //   const delivered = Math.round(sent * 0.98);
// // //   const opened = Math.round(sent * 0.46);
// // //   const replies = Math.round(sent * 0.07);
// // //   const log = Array.from({ length: 6 }, (_, k) => sent - k).filter((n) => n > 0);

// // //   return (
// // //     <div className="w-[min(90vw,920px)] mx-auto select-none">
// // //       {/* крышка */}
// // //       <div
// // //         className="relative rounded-[22px] p-[10px] shadow-[0_40px_120px_-20px_rgba(37,99,235,0.55)]"
// // //         style={{ background: 'linear-gradient(160deg,#2b2f38,#0d0f14)', border: '1px solid #3a3f4b' }}
// // //       >
// // //         <div className="relative rounded-[12px] overflow-hidden bg-[#020814]" style={{ aspectRatio: '16 / 10' }}>
// // //           <BinaryRain pRef={pRef} />
// // //           {/* вырез камеры */}
// // //           <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[14%] h-[4%] bg-black rounded-b-lg z-20" />

// // //           {/* стартовая строка */}
// // //           <div
// // //             className="absolute inset-0 flex items-center justify-center font-mono text-blue-300 text-sm md:text-lg z-10"
// // //             style={{ opacity: 1 - seg(p, 0.1, 0.22) }}
// // //           >
// // //             <span>&gt; mailora --send campaign_b2b</span>
// // //             <span className="ml-1 w-2 h-5 bg-blue-300 animate-pulse" />
// // //           </div>

// // //           {/* окно рассылки */}
// // //           <div
// // //             className="absolute inset-[7%] rounded-xl bg-[#0a1226]/85 backdrop-blur-md border border-blue-400/25 p-3 md:p-5 text-white z-10 flex flex-col"
// // //             style={{ opacity: panel, transform: `translateY(${(1 - panel) * 24}px)` }}
// // //           >
// // //             <div className="flex items-center gap-1.5 mb-3">
// // //               <span className="w-2.5 h-2.5 rounded-full bg-red-400" />
// // //               <span className="w-2.5 h-2.5 rounded-full bg-yellow-400" />
// // //               <span className="w-2.5 h-2.5 rounded-full bg-green-400" />
// // //               <span className="ml-3 text-[11px] md:text-xs text-blue-200/70">Кампания «Новые клиенты Q4»</span>
// // //             </div>
// // //             <div className="flex items-end justify-between">
// // //               <div>
// // //                 <div className="text-3xl md:text-5xl font-bold tabular-nums leading-none">{sent}</div>
// // //                 <div className="text-[11px] md:text-xs text-blue-200/70 mt-1">писем отправлено из {TOTAL}</div>
// // //               </div>
// // //               <div className="hidden sm:flex gap-5 text-right text-[11px] md:text-xs text-blue-200/70">
// // //                 <div><div className="text-base md:text-lg text-white tabular-nums">{delivered}</div>доставлено</div>
// // //                 <div><div className="text-base md:text-lg text-white tabular-nums">{opened}</div>открыто</div>
// // //                 <div><div className="text-base md:text-lg text-emerald-300 tabular-nums">{replies}</div>ответов</div>
// // //               </div>
// // //             </div>
// // //             <div className="h-1.5 rounded-full bg-white/10 mt-3 overflow-hidden">
// // //               <div className="h-full bg-blue-500" style={{ width: `${(sent / TOTAL) * 100}%` }} />
// // //             </div>
// // //             <ul className="mt-3 space-y-1 font-mono text-[10px] md:text-xs overflow-hidden">
// // //               {log.map((n) => (
// // //                 <li key={n} className="flex justify-between text-blue-100/80">
// // //                   <span className="truncate">{mail(n)}</span>
// // //                   <span className="text-emerald-300 ml-3 shrink-0">отправлено</span>
// // //                 </li>
// // //               ))}
// // //             </ul>
// // //           </div>
// // //         </div>
// // //       </div>
// // //       {/* основание */}
// // //       <div
// // //         className="mx-auto h-[14px] rounded-b-[18px] w-[112%] -ml-[6%] relative"
// // //         style={{ background: 'linear-gradient(#c9ccd3,#8b8f98)', boxShadow: '0 20px 40px rgba(0,0,0,.5)' }}
// // //       >
// // //         <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[16%] h-[5px] rounded-b-md bg-[#6b6f78]" />
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // /* ---------- Три основных блока ---------- */
// // // const BOXES = [
// // //   { m: 'sales@brand.ru', v: 96 },
// // //   { m: 'ceo@brand.ru', v: 88 },
// // //   { m: 'hello@brand-mail.ru', v: 61 },
// // // ];
// // // const STEPS = [
// // //   ['День 1', 'Первое письмо с обращением по имени'],
// // //   ['День 3', 'Короткое напоминание'],
// // //   ['День 7', 'Последнее касание с предложением созвониться'],
// // // ];
// // // const REPLIES = [
// // //   ['Логист-Про', 'Да, пришлите коммерческое предложение', 'новый'],
// // //   ['Агрохолдинг', 'Давайте созвонимся во вторник', 'новый'],
// // //   ['Промснаб', 'Сейчас не актуально, вернёмся в январе', 'прочитан'],
// // // ];

// // // function Panel({ children }) {
// // //   return (
// // //     <div className="rounded-2xl border border-blue-400/20 bg-[#0a1226] p-5 md:p-6 shadow-[0_30px_80px_-30px_rgba(37,99,235,0.5)]">
// // //       {children}
// // //     </div>
// // //   );
// // // }

// // // function Row({ title, text, flip, children }) {
// // //   return (
// // //     <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
// // //       <div className={flip ? 'md:order-2' : ''}>
// // //         <h3 className="text-3xl md:text-4xl font-bold leading-tight">{title}</h3>
// // //         <p className="mt-4 text-lg text-blue-100/70 max-w-[46ch]">{text}</p>
// // //       </div>
// // //       <div className={flip ? 'md:order-1' : ''}>{children}</div>
// // //     </div>
// // //   );
// // // }

// // // function Features() {
// // //   return (
// // //     <section className="relative bg-[#020814] px-4 pt-24 pb-28">
// // //       <div className="max-w-6xl mx-auto space-y-28 md:space-y-36">
// // //         <Row
// // //           title="Письма доходят до людей, а не до спама"
// // //           text="Подключите свои ящики, мы прогреем их и будем следить за репутацией. Отправка идёт понемногу с разных адресов, чтобы почтовые сервисы не считали её массовой."
// // //         >
// // //           <Panel>
// // //             <div className="space-y-4">
// // //               {BOXES.map((b) => (
// // //                 <div key={b.m}>
// // //                   <div className="flex justify-between text-sm">
// // //                     <span className="font-mono text-blue-100">{b.m}</span>
// // //                     <span className="text-blue-200/70">репутация {b.v}%</span>
// // //                   </div>
// // //                   <div className="h-2 rounded-full bg-white/10 mt-2 overflow-hidden">
// // //                     <div
// // //                       className={`h-full rounded-full ${b.v > 80 ? 'bg-emerald-400' : 'bg-amber-400'}`}
// // //                       style={{ width: `${b.v}%` }}
// // //                     />
// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </div>
// // //           </Panel>
// // //         </Row>

// // //         <Row
// // //           flip
// // //           title="Одна цепочка вместо десяти ручных писем"
// // //           text="Опишите последовательность один раз: первое письмо, напоминания, финальное касание. Когда клиент ответил, цепочка для него останавливается сама."
// // //         >
// // //           <Panel>
// // //             <ol className="relative border-l border-blue-400/30 ml-2 space-y-5">
// // //               {STEPS.map(([d, t]) => (
// // //                 <li key={d} className="pl-6 relative">
// // //                   <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-blue-500" />
// // //                   <div className="text-sm text-blue-300">{d}</div>
// // //                   <div className="text-base">{t}</div>
// // //                 </li>
// // //               ))}
// // //               <li className="pl-6 relative">
// // //                 <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-emerald-400" />
// // //                 <div className="text-base text-emerald-300">Клиент ответил: цепочка остановлена</div>
// // //               </li>
// // //             </ol>
// // //           </Panel>
// // //         </Row>

// // //         <Row
// // //           title="Все ответы в одном месте"
// // //           text="Не нужно открывать десять почтовых ящиков. Ответы клиентов собираются в одной ленте, и вы сразу видите, с кем пора говорить."
// // //         >
// // //           <Panel>
// // //             <ul className="divide-y divide-white/10">
// // //               {REPLIES.map(([n, t, s]) => (
// // //                 <li key={n} className="py-3 first:pt-0 last:pb-0 flex items-start justify-between gap-4">
// // //                   <div>
// // //                     <div className="font-medium">{n}</div>
// // //                     <div className="text-sm text-blue-100/70">{t}</div>
// // //                   </div>
// // //                   <span
// // //                     className={`text-xs px-2 py-1 rounded-full shrink-0 ${
// // //                       s === 'новый' ? 'bg-blue-500/20 text-blue-300' : 'bg-white/10 text-blue-200/60'
// // //                     }`}
// // //                   >
// // //                     {s}
// // //                   </span>
// // //                 </li>
// // //               ))}
// // //             </ul>
// // //           </Panel>
// // //         </Row>
// // //       </div>
// // //     </section>
// // //   );
// // // }

// // // /* ---------- Страница ---------- */
// // // export default function Landing() {
// // //   const { isAuthenticated, loading } = useAuth();
// // //   const sceneRef = useRef(null);
// // //   const pRef = useRef(0);
// // //   const [p, setP] = useState(0);

// // //   useEffect(() => {
// // //     if (!loading && isAuthenticated && APP_URL) {
// // //       window.location.href = `${APP_URL}/dashboard`;
// // //     }
// // //   }, [loading, isAuthenticated]);

// // //   useEffect(() => {
// // //     if (loading) return;
// // //     let raf = 0;
// // //     const update = () => {
// // //       raf = 0;
// // //       const el = sceneRef.current;
// // //       if (!el) return;
// // //       const r = el.getBoundingClientRect();
// // //       const v = clamp(-r.top / (r.height - window.innerHeight));
// // //       pRef.current = v;
// // //       setP(v);
// // //     };
// // //     const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
// // //     update();
// // //     window.addEventListener('scroll', onScroll, { passive: true });
// // //     window.addEventListener('resize', onScroll);
// // //     return () => {
// // //       window.removeEventListener('scroll', onScroll);
// // //       window.removeEventListener('resize', onScroll);
// // //       if (raf) cancelAnimationFrame(raf);
// // //     };
// // //   }, [loading]);

// // //   if (loading) {
// // //     return (
// // //       <div className="min-h-screen flex items-center justify-center bg-gray-50">
// // //         <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
// // //       </div>
// // //     );
// // //   }

// // //   // Параллакс и зум ноутбука
// // //   const zoom = easeOut(seg(p, 0.04, 0.4));
// // //   const tilt = lerp(28, 0, easeOut(seg(p, 0, 0.3)));
// // //   const scale = lerp(0.78, 1.08, zoom);
// // //   const y = lerp(50, 10, easeOut(seg(p, 0, 0.3)));
// // //   const heroOpacity = 1 - seg(p, 0.03, 0.14);
// // //   const cap2 = seg(p, 0.14, 0.22) * (1 - seg(p, 0.42, 0.5));
// // //   const cap3 = seg(p, 0.5, 0.6);

// // //   return (
// // //     <div className="min-h-screen bg-[#020814] text-white">
// // //       {/* Шапка */}
// // //       <header className="fixed top-0 inset-x-0 z-50">
// // //         <div className="max-w-6xl mx-auto px-4 py-5 flex items-center justify-between">
// // //           <Link to="/" className="flex items-center gap-2 text-xl font-bold text-blue-400">
// // //             <span className="w-2 h-2 rounded-full bg-blue-400 inline-block" />
// // //             MAILORA
// // //           </Link>
// // //           <div className="flex gap-3">
// // //             <Link to="/login" className="px-4 py-2 rounded-xl text-blue-100 hover:bg-white/10 transition">
// // //               Войти
// // //             </Link>
// // //             <Link to="/register" className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-500 transition shadow-md">
// // //               Регистрация
// // //             </Link>
// // //           </div>
// // //         </div>
// // //       </header>

// // //       {/* Сцена со скроллом: 330vh высоты, внутри — «липкий» экран */}
// // //       <section ref={sceneRef} className="relative" style={{ height: '330vh' }}>
// // //         <div className="sticky top-0 h-screen overflow-hidden">
// // //           {/* слои фона с разной скоростью */}
// // //           <div
// // //             className="absolute -left-40 top-10 w-[520px] h-[520px] rounded-full bg-blue-600/25 blur-[120px]"
// // //             style={{ transform: `translateY(${p * -260}px)` }}
// // //           />
// // //           <div
// // //             className="absolute -right-32 bottom-0 w-[460px] h-[460px] rounded-full bg-indigo-500/20 blur-[120px]"
// // //             style={{ transform: `translateY(${p * 320}px)` }}
// // //           />

// // //           {/* заголовок первого экрана */}
// // //           <div
// // //             className="absolute inset-x-0 top-[13vh] px-4 text-center z-10"
// // //             style={{ opacity: heroOpacity, transform: `translateY(${p * -160}px)` }}
// // //           >
// // //             <span className="inline-block text-xs font-semibold tracking-wider uppercase text-blue-300 bg-blue-500/15 px-3 py-1 rounded-full mb-5">
// // //               Мы запустились!
// // //             </span>
// // //             <h1 className="text-4xl md:text-6xl font-bold leading-tight">Сервис для email рассылок</h1>
// // //             <p className="mt-4 text-base md:text-lg text-blue-100/70 max-w-[56ch] mx-auto">
// // //               Привлекайте новых клиентов в B2B сегменте с помощью деловой коммуникации через email переписки.
// // //             </p>
// // //             <Link
// // //               to="/register"
// // //               className="inline-block mt-7 px-6 py-3 rounded-xl bg-blue-600 text-white font-medium hover:bg-blue-500 transition shadow-lg"
// // //             >
// // //               Попробовать бесплатно 7 дней
// // //             </Link>
// // //           </div>

// // //           {/* подписи по ходу скролла */}
// // //           <div
// // //             className="absolute inset-x-0 top-[10vh] text-center px-4 z-10 pointer-events-none"
// // //             style={{ opacity: cap2 }}
// // //           >
// // //             <h2 className="text-2xl md:text-4xl font-bold">Одно нажатие — и код оживает</h2>
// // //           </div>
// // //           <div
// // //             className="absolute inset-x-0 top-[10vh] text-center px-4 z-10"
// // //             style={{ opacity: cap3 }}
// // //           >
// // //             <h2 className="text-2xl md:text-4xl font-bold">Сотни писем ушли, пока вы пили кофе</h2>
// // //             <Link
// // //               to="/register"
// // //               className="inline-block mt-5 px-6 py-3 rounded-xl bg-blue-600 text-white font-medium hover:bg-blue-500 transition shadow-lg"
// // //             >
// // //               Попробовать бесплатно 7 дней
// // //             </Link>
// // //           </div>

// // //           {/* MacBook */}
// // //           <div
// // //             className="absolute inset-x-0 bottom-[6vh] z-0"
// // //             style={{
// // //               transform: `translateY(${y}px)`,
// // //               perspective: '1600px',
// // //             }}
// // //           >
// // //             <div style={{ transform: `rotateX(${tilt}deg) scale(${scale})`, transformOrigin: '50% 100%' }}>
// // //               <MacBook p={p} pRef={pRef} />
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       <Features />

// // //       {/* Футер */}
// // //       <footer id="footer" className="bg-white text-gray-900 border-t border-gray-200 py-10">
// // //         <div className="max-w-6xl mx-auto px-4">
// // //           <div className="text-[13px] leading-relaxed text-gray-500 font-light">
// // //             <div className="flex flex-wrap gap-x-6 gap-y-1">
// // //               <span><span className="text-gray-400">ИП</span> Сидоренко Руслан Владимирович</span>
// // //               <span><span className="text-gray-400">ИНН</span> 611300126009</span>
// // //               <span><span className="text-gray-400">ОГРНИП</span> 317619600088799</span>
// // //             </div>
// // //           </div>
// // //           <div className="border-t border-gray-200 mt-6 pt-6 text-[13px] text-gray-500 font-light">
// // //             © {new Date().getFullYear()} Mailora. Все права защищены.
// // //           </div>
// // //         </div>
// // //       </footer>

// // //       <CookieBanner />
// // //     </div>
// // //   );
// // // }

// // // import React, { useEffect, useRef, useState } from 'react';
// // // import { Link } from 'react-router-dom';
// // // import { useAuth } from '../AuthContext';
// // // import CookieBanner from '../CookieBanner';

// // // const APP_URL = process.env.REACT_APP_APP_URL;

// // // const TOTAL = 500; // сколько писем «отправляем» в сцене
// // // const NAMES = ['ivanov', 'a.smirnova', 'director', 'sales', 'p.kuznetsov', 'info', 'm.orlova', 'ceo', 'zakupki', 'k.belov', 'hr', 'o.volkova'];
// // // const DOMAINS = ['stroytech.ru', 'logist-pro.ru', 'agroholding.ru', 'medline.ru', 'promsnab.ru', 'it-partner.ru', 'retail-group.ru', 'energo.ru'];

// // // const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
// // // const lerp = (a, b, t) => a + (b - a) * t;
// // // const seg = (p, a, b) => clamp((p - a) / (b - a));
// // // const easeOut = (t) => 1 - Math.pow(1 - t, 3);
// // // const mail = (i) => `${NAMES[i % NAMES.length]}@${DOMAINS[(i * 7) % DOMAINS.length]}`;

// // // /* ---------- Matrix: дождь из 1 и 0 на canvas ---------- */
// // // function BinaryRain({ pRef }) {
// // //   const ref = useRef(null);
// // //   useEffect(() => {
// // //     const c = ref.current;
// // //     const ctx = c.getContext('2d');
// // //     const W = 640, H = 400, size = 14;
// // //     c.width = W; c.height = H;
// // //     const cols = Math.floor(W / size);
// // //     const drops = Array.from({ length: cols }, () => Math.random() * -40);
// // //     let raf, last = 0;
// // //     const draw = (t) => {
// // //       raf = requestAnimationFrame(draw);
// // //       if (t - last < 45) return;
// // //       last = t;
// // //       const p = pRef.current;
// // //       const power = seg(p, 0.08, 0.4); // с какого момента «оживает»
// // //       ctx.fillStyle = 'rgba(2, 8, 20, 0.16)';
// // //       ctx.fillRect(0, 0, W, H);
// // //       ctx.font = `${size}px ui-monospace, Menlo, monospace`;
// // //       const active = Math.floor(cols * (0.15 + 0.85 * power));
// // //       for (let i = 0; i < active; i++) {
// // //         const x = i * size;
// // //         const y = drops[i] * size;
// // //         ctx.fillStyle = '#e8f1ff';
// // //         ctx.fillText(Math.random() > 0.5 ? '1' : '0', x, y);
// // //         ctx.fillStyle = `rgba(59, 130, 246, ${0.35 + 0.5 * power})`;
// // //         ctx.fillText(Math.random() > 0.5 ? '1' : '0', x, y - size);
// // //         drops[i] += 0.6 + power * 1.2;
// // //         if (y > H && Math.random() > 0.96) drops[i] = Math.random() * -10;
// // //       }
// // //     };
// // //     raf = requestAnimationFrame(draw);
// // //     return () => cancelAnimationFrame(raf);
// // //   }, [pRef]);
// // //   return <canvas ref={ref} className="absolute inset-0 w-full h-full" aria-hidden="true" />;
// // // }

// // // /* ---------- MacBook ---------- */
// // // function MacBook({ p, pRef }) {
// // //   const sent = Math.round(easeOut(seg(p, 0.24, 0.9)) * TOTAL);
// // //   const panel = seg(p, 0.2, 0.3);
// // //   const delivered = Math.round(sent * 0.98);
// // //   const opened = Math.round(sent * 0.46);
// // //   const replies = Math.round(sent * 0.07);
// // //   const log = Array.from({ length: 6 }, (_, k) => sent - k).filter((n) => n > 0);

// // //   return (
// // //     <div className="w-[min(90vw,920px)] mx-auto select-none">
// // //       {/* крышка */}
// // //       <div
// // //         className="relative rounded-[22px] p-[10px] shadow-[0_40px_120px_-20px_rgba(37,99,235,0.55)]"
// // //         style={{ background: 'linear-gradient(160deg,#2b2f38,#0d0f14)', border: '1px solid #3a3f4b' }}
// // //       >
// // //         <div className="relative rounded-[12px] overflow-hidden bg-[#020814]" style={{ aspectRatio: '16 / 10' }}>
// // //           <BinaryRain pRef={pRef} />
// // //           {/* вырез камеры */}
// // //           <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[14%] h-[4%] bg-black rounded-b-lg z-20" />

// // //           {/* стартовая строка */}
// // //           <div
// // //             className="absolute inset-0 flex items-center justify-center font-mono text-blue-300 text-sm md:text-lg z-10"
// // //             style={{ opacity: 1 - seg(p, 0.1, 0.22) }}
// // //           >
// // //             <span>&gt; mailora --send campaign_b2b</span>
// // //             <span className="ml-1 w-2 h-5 bg-blue-300 animate-pulse" />
// // //           </div>

// // //           {/* окно рассылки */}
// // //           <div
// // //             className="absolute inset-[7%] rounded-xl bg-[#0a1226]/85 backdrop-blur-md border border-blue-400/25 p-3 md:p-5 text-white z-10 flex flex-col"
// // //             style={{ opacity: panel, transform: `translateY(${(1 - panel) * 24}px)` }}
// // //           >
// // //             <div className="flex items-center gap-1.5 mb-3">
// // //               <span className="w-2.5 h-2.5 rounded-full bg-red-400" />
// // //               <span className="w-2.5 h-2.5 rounded-full bg-yellow-400" />
// // //               <span className="w-2.5 h-2.5 rounded-full bg-green-400" />
// // //               <span className="ml-3 text-[11px] md:text-xs text-blue-200/70">Кампания «Новые клиенты Q4»</span>
// // //             </div>
// // //             <div className="flex items-end justify-between">
// // //               <div>
// // //                 <div className="text-3xl md:text-5xl font-bold tabular-nums leading-none">{sent}</div>
// // //                 <div className="text-[11px] md:text-xs text-blue-200/70 mt-1">писем отправлено из {TOTAL}</div>
// // //               </div>
// // //               <div className="hidden sm:flex gap-5 text-right text-[11px] md:text-xs text-blue-200/70">
// // //                 <div><div className="text-base md:text-lg text-white tabular-nums">{delivered}</div>доставлено</div>
// // //                 <div><div className="text-base md:text-lg text-white tabular-nums">{opened}</div>открыто</div>
// // //                 <div><div className="text-base md:text-lg text-emerald-300 tabular-nums">{replies}</div>ответов</div>
// // //               </div>
// // //             </div>
// // //             <div className="h-1.5 rounded-full bg-white/10 mt-3 overflow-hidden">
// // //               <div className="h-full bg-blue-500" style={{ width: `${(sent / TOTAL) * 100}%` }} />
// // //             </div>
// // //             <ul className="mt-3 space-y-1 font-mono text-[10px] md:text-xs overflow-hidden">
// // //               {log.map((n) => (
// // //                 <li key={n} className="flex justify-between text-blue-100/80">
// // //                   <span className="truncate">{mail(n)}</span>
// // //                   <span className="text-emerald-300 ml-3 shrink-0">отправлено</span>
// // //                 </li>
// // //               ))}
// // //             </ul>
// // //           </div>
// // //         </div>
// // //       </div>
// // //       {/* основание */}
// // //       <div
// // //         className="mx-auto h-[14px] rounded-b-[18px] w-[112%] -ml-[6%] relative"
// // //         style={{ background: 'linear-gradient(#c9ccd3,#8b8f98)', boxShadow: '0 20px 40px rgba(0,0,0,.5)' }}
// // //       >
// // //         <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[16%] h-[5px] rounded-b-md bg-[#6b6f78]" />
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // /* ---------- Три основных блока ---------- */
// // // const BOXES = [
// // //   { m: 'sales@brand.ru', v: 96 },
// // //   { m: 'ceo@brand.ru', v: 88 },
// // //   { m: 'hello@brand-mail.ru', v: 61 },
// // // ];
// // // const STEPS = [
// // //   ['День 1', 'Первое письмо с обращением по имени'],
// // //   ['День 3', 'Короткое напоминание'],
// // //   ['День 7', 'Последнее касание с предложением созвониться'],
// // // ];
// // // const REPLIES = [
// // //   ['Логист-Про', 'Да, пришлите коммерческое предложение', 'новый'],
// // //   ['Агрохолдинг', 'Давайте созвонимся во вторник', 'новый'],
// // //   ['Промснаб', 'Сейчас не актуально, вернёмся в январе', 'прочитан'],
// // // ];

// // // function Panel({ children }) {
// // //   return (
// // //     <div className="rounded-2xl border border-blue-400/20 bg-[#0a1226] p-5 md:p-6 shadow-[0_30px_80px_-30px_rgba(37,99,235,0.5)]">
// // //       {children}
// // //     </div>
// // //   );
// // // }

// // // function Row({ title, text, flip, children }) {
// // //   return (
// // //     <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
// // //       <div className={flip ? 'md:order-2' : ''}>
// // //         <h3 className="text-3xl md:text-4xl font-bold leading-tight">{title}</h3>
// // //         <p className="mt-4 text-lg text-blue-100/70 max-w-[46ch]">{text}</p>
// // //       </div>
// // //       <div className={flip ? 'md:order-1' : ''}>{children}</div>
// // //     </div>
// // //   );
// // // }

// // // function Features() {
// // //   return (
// // //     <section className="relative bg-[#020814] px-4 pt-14 pb-28">
// // //       <div className="max-w-6xl mx-auto space-y-28 md:space-y-36">
// // //         <Row
// // //           title="Письма доходят до людей, а не до спама"
// // //           text="Подключите свои ящики, мы прогреем их и будем следить за репутацией. Отправка идёт понемногу с разных адресов, чтобы почтовые сервисы не считали её массовой."
// // //         >
// // //           <Panel>
// // //             <div className="space-y-4">
// // //               {BOXES.map((b) => (
// // //                 <div key={b.m}>
// // //                   <div className="flex justify-between text-sm">
// // //                     <span className="font-mono text-blue-100">{b.m}</span>
// // //                     <span className="text-blue-200/70">репутация {b.v}%</span>
// // //                   </div>
// // //                   <div className="h-2 rounded-full bg-white/10 mt-2 overflow-hidden">
// // //                     <div
// // //                       className={`h-full rounded-full ${b.v > 80 ? 'bg-emerald-400' : 'bg-amber-400'}`}
// // //                       style={{ width: `${b.v}%` }}
// // //                     />
// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </div>
// // //           </Panel>
// // //         </Row>

// // //         <Row
// // //           flip
// // //           title="Одна цепочка вместо десяти ручных писем"
// // //           text="Опишите последовательность один раз: первое письмо, напоминания, финальное касание. Когда клиент ответил, цепочка для него останавливается сама."
// // //         >
// // //           <Panel>
// // //             <ol className="relative border-l border-blue-400/30 ml-2 space-y-5">
// // //               {STEPS.map(([d, t]) => (
// // //                 <li key={d} className="pl-6 relative">
// // //                   <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-blue-500" />
// // //                   <div className="text-sm text-blue-300">{d}</div>
// // //                   <div className="text-base">{t}</div>
// // //                 </li>
// // //               ))}
// // //               <li className="pl-6 relative">
// // //                 <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-emerald-400" />
// // //                 <div className="text-base text-emerald-300">Клиент ответил: цепочка остановлена</div>
// // //               </li>
// // //             </ol>
// // //           </Panel>
// // //         </Row>

// // //         <Row
// // //           title="Все ответы в одном месте"
// // //           text="Не нужно открывать десять почтовых ящиков. Ответы клиентов собираются в одной ленте, и вы сразу видите, с кем пора говорить."
// // //         >
// // //           <Panel>
// // //             <ul className="divide-y divide-white/10">
// // //               {REPLIES.map(([n, t, s]) => (
// // //                 <li key={n} className="py-3 first:pt-0 last:pb-0 flex items-start justify-between gap-4">
// // //                   <div>
// // //                     <div className="font-medium">{n}</div>
// // //                     <div className="text-sm text-blue-100/70">{t}</div>
// // //                   </div>
// // //                   <span
// // //                     className={`text-xs px-2 py-1 rounded-full shrink-0 ${
// // //                       s === 'новый' ? 'bg-blue-500/20 text-blue-300' : 'bg-white/10 text-blue-200/60'
// // //                     }`}
// // //                   >
// // //                     {s}
// // //                   </span>
// // //                 </li>
// // //               ))}
// // //             </ul>
// // //           </Panel>
// // //         </Row>
// // //       </div>
// // //     </section>
// // //   );
// // // }

// // // /* ---------- Страница ---------- */
// // // export default function Landing() {
// // //   const { isAuthenticated, loading } = useAuth();
// // //   const sceneRef = useRef(null);
// // //   const pRef = useRef(0);
// // //   const [p, setP] = useState(0);

// // //   useEffect(() => {
// // //     if (!loading && isAuthenticated && APP_URL) {
// // //       window.location.href = `${APP_URL}/dashboard`;
// // //     }
// // //   }, [loading, isAuthenticated]);

// // //   useEffect(() => {
// // //     if (loading) return;
// // //     let raf = 0;
// // //     const update = () => {
// // //       raf = 0;
// // //       const el = sceneRef.current;
// // //       if (!el) return;
// // //       const r = el.getBoundingClientRect();
// // //       const v = clamp(-r.top / (r.height - window.innerHeight));
// // //       pRef.current = v;
// // //       setP(v);
// // //     };
// // //     const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
// // //     update();
// // //     window.addEventListener('scroll', onScroll, { passive: true });
// // //     window.addEventListener('resize', onScroll);
// // //     return () => {
// // //       window.removeEventListener('scroll', onScroll);
// // //       window.removeEventListener('resize', onScroll);
// // //       if (raf) cancelAnimationFrame(raf);
// // //     };
// // //   }, [loading]);

// // //   if (loading) {
// // //     return (
// // //       <div className="min-h-screen flex items-center justify-center bg-gray-50">
// // //         <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
// // //       </div>
// // //     );
// // //   }

// // //   // Параллакс и зум ноутбука
// // //   const zoom = easeOut(seg(p, 0.04, 0.4));
// // //   const tilt = lerp(28, 0, easeOut(seg(p, 0, 0.3)));
// // //   const scale = lerp(0.78, 1.08, zoom);
// // //   const y = lerp(40, 0, easeOut(seg(p, 0, 0.3)));
// // //   const heroOpacity = 1 - seg(p, 0.03, 0.14);
// // //   const cap2 = seg(p, 0.14, 0.22) * (1 - seg(p, 0.42, 0.5));
// // //   const cap3 = seg(p, 0.5, 0.6);

// // //   return (
// // //     <div className="min-h-screen bg-[#020814] text-white">
// // //       {/* Шапка */}
// // //       <header className="fixed top-0 inset-x-0 z-50">
// // //         <div className="max-w-6xl mx-auto px-4 py-5 flex items-center justify-between">
// // //           <Link to="/" className="flex items-center gap-2 text-xl font-bold text-blue-400">
// // //             <span className="w-2 h-2 rounded-full bg-blue-400 inline-block" />
// // //             MAILORA
// // //           </Link>
// // //           <div className="flex gap-3">
// // //             <Link to="/login" className="px-4 py-2 rounded-xl text-blue-100 hover:bg-white/10 transition">
// // //               Войти
// // //             </Link>
// // //             <Link to="/register" className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-500 transition shadow-md">
// // //               Регистрация
// // //             </Link>
// // //           </div>
// // //         </div>
// // //       </header>

// // //       {/* Сцена со скроллом: 330vh высоты, внутри — «липкий» экран */}
// // //       <section ref={sceneRef} className="relative" style={{ height: '330vh' }}>
// // //         <div className="sticky top-0 h-screen overflow-hidden">
// // //           {/* слои фона с разной скоростью */}
// // //           <div
// // //             className="absolute -left-40 top-10 w-[520px] h-[520px] rounded-full bg-blue-600/25 blur-[120px]"
// // //             style={{ transform: `translateY(${p * -260}px)` }}
// // //           />
// // //           <div
// // //             className="absolute -right-32 bottom-0 w-[460px] h-[460px] rounded-full bg-indigo-500/20 blur-[120px]"
// // //             style={{ transform: `translateY(${p * 320}px)` }}
// // //           />

// // //           {/* заголовок первого экрана */}
// // //           <div
// // //             className="absolute inset-x-0 top-[13vh] px-4 text-center z-10"
// // //             style={{ opacity: heroOpacity, transform: `translateY(${p * -160}px)` }}
// // //           >
// // //             <span className="inline-block text-xs font-semibold tracking-wider uppercase text-blue-300 bg-blue-500/15 px-3 py-1 rounded-full mb-5">
// // //               Мы запустились!
// // //             </span>
// // //             <h1 className="text-4xl md:text-6xl font-bold leading-tight">Сервис для email рассылок</h1>
// // //             <p className="mt-4 text-base md:text-lg text-blue-100/70 max-w-[56ch] mx-auto">
// // //               Привлекайте новых клиентов в B2B сегменте с помощью деловой коммуникации через email переписки.
// // //             </p>
// // //             <Link
// // //               to="/register"
// // //               className="inline-block mt-7 px-6 py-3 rounded-xl bg-blue-600 text-white font-medium hover:bg-blue-500 transition shadow-lg"
// // //             >
// // //               Попробовать бесплатно 7 дней
// // //             </Link>
// // //           </div>

// // //           {/* подписи по ходу скролла */}
// // //           <div
// // //             className="absolute inset-x-0 top-[10vh] text-center px-4 z-10 pointer-events-none"
// // //             style={{ opacity: cap2 }}
// // //           >
// // //             <h2 className="text-2xl md:text-4xl font-bold">Одно нажатие — и код оживает</h2>
// // //           </div>
// // //           <div
// // //             className="absolute inset-x-0 top-[10vh] text-center px-4 z-10"
// // //             style={{ opacity: cap3 }}
// // //           >
// // //             <h2 className="text-2xl md:text-4xl font-bold">Сотни писем ушли, пока вы пили кофе</h2>
// // //             <Link
// // //               to="/register"
// // //               className="inline-block mt-5 px-6 py-3 rounded-xl bg-blue-600 text-white font-medium hover:bg-blue-500 transition shadow-lg"
// // //             >
// // //               Попробовать бесплатно 7 дней
// // //             </Link>
// // //           </div>

// // //           {/* MacBook */}
// // //           <div
// // //             className="absolute inset-x-0 bottom-0 z-0"
// // //             style={{
// // //               transform: `translateY(${y}px)`,
// // //               perspective: '1600px',
// // //             }}
// // //           >
// // //             <div style={{ transform: `rotateX(${tilt}deg) scale(${scale})`, transformOrigin: '50% 100%' }}>
// // //               <MacBook p={p} pRef={pRef} />
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       <Features />

// // //       {/* Футер */}
// // //       <footer id="footer" className="bg-white text-gray-900 border-t border-gray-200 py-10">
// // //         <div className="max-w-6xl mx-auto px-4">
// // //           <div className="text-[13px] leading-relaxed text-gray-500 font-light">
// // //             <div className="flex flex-wrap gap-x-6 gap-y-1">
// // //               <span><span className="text-gray-400">ИП</span> Сидоренко Руслан Владимирович</span>
// // //               <span><span className="text-gray-400">ИНН</span> 611300126009</span>
// // //               <span><span className="text-gray-400">ОГРНИП</span> 317619600088799</span>
// // //             </div>
// // //           </div>
// // //           <div className="border-t border-gray-200 mt-6 pt-6 text-[13px] text-gray-500 font-light">
// // //             © {new Date().getFullYear()} Mailora. Все права защищены.
// // //           </div>
// // //         </div>
// // //       </footer>

// // //       <CookieBanner />
// // //     </div>
// // //   );
// // // }

// // import React, { useEffect, useRef, useState } from 'react';
// // import { Link } from 'react-router-dom';
// // import { useAuth } from '../AuthContext';
// // import CookieBanner from '../CookieBanner';

// // const APP_URL = process.env.REACT_APP_APP_URL;

// // const TOTAL = 500;
// // const NAMES = ['ivanov', 'a.smirnova', 'director', 'sales', 'p.kuznetsov', 'info', 'm.orlova', 'ceo', 'zakupki', 'k.belov', 'hr', 'o.volkova'];
// // const DOMAINS = ['stroytech.ru', 'logist-pro.ru', 'agroholding.ru', 'medline.ru', 'promsnab.ru', 'it-partner.ru', 'retail-group.ru', 'energo.ru'];

// // const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
// // const lerp = (a, b, t) => a + (b - a) * t;
// // const seg = (p, a, b) => clamp((p - a) / (b - a));
// // const easeOut = (t) => 1 - Math.pow(1 - t, 3);
// // const mail = (i) => `${NAMES[i % NAMES.length]}@${DOMAINS[(i * 7) % DOMAINS.length]}`;

// // /* ---------- Electric circuit: конверты бегут по дорожкам ---------- */
// // function CircuitFlow({ pRef }) {
// //   const ref = useRef(null);

// //   useEffect(() => {
// //     const c = ref.current;
// //     const ctx = c.getContext('2d');
// //     const W = 640, H = 400;
// //     const dpr = window.devicePixelRatio || 1;
// //     c.width = W * dpr;
// //     c.height = H * dpr;
// //     c.style.width = '100%';
// //     c.style.height = '100%';
// //     ctx.scale(dpr, dpr);

// //     // Дорожки — каждая со своей высотой, амплитудой и фазой
// //     const TRACKS = 5;
// //     const tracks = Array.from({ length: TRACKS }, (_, i) => ({
// //       baseY: (H / (TRACKS + 1)) * (i + 1),
// //       amp: 14 + (i % 3) * 10,
// //       freq: 0.008 + i * 0.003,
// //       phase: i * 1.7,
// //       particles: [],
// //     }));

// //     // Рисуем конверт
// //     const drawEnvelope = (x, y, size, rotation, color, alpha) => {
// //       ctx.save();
// //       ctx.translate(x, y);
// //       ctx.rotate(rotation);
// //       ctx.globalAlpha = alpha;

// //       ctx.strokeStyle = color;
// //       ctx.lineWidth = 1.5;
// //       ctx.strokeRect(-size / 2, -size * 0.7, size, size * 1.4);

// //       ctx.beginPath();
// //       ctx.moveTo(-size / 2, -size * 0.7);
// //       ctx.lineTo(0, size * 0.15);
// //       ctx.lineTo(size / 2, -size * 0.7);
// //       ctx.stroke();

// //       ctx.restore();
// //     };

// //     // Создаём частицу на дорожке
// //     const spawn = (track, startX = -30) => {
// //       track.particles.push({
// //         x: startX,
// //         yOffset: (Math.random() - 0.5) * 6,
// //         size: 10 + Math.random() * 6,
// //         speed: 0.6 + Math.random() * 0.6,
// //         delay: Math.random() * 60,
// //       });
// //     };

// //     // Начальное заполнение
// //     tracks.forEach((t) => {
// //       const count = 4 + Math.floor(Math.random() * 3);
// //       for (let i = 0; i < count; i++) {
// //         spawn(t, -30 - Math.random() * 200);
// //       }
// //     });

// //     let raf, last = 0;
// //     let spawnTimer = 0;

// //     const draw = (t) => {
// //       raf = requestAnimationFrame(draw);
// //       if (t - last < 32) return;
// //       const dt = (t - last) / 16;
// //       last = t;

// //       const p = pRef.current;
// //       const power = seg(p, 0.08, 0.85);

// //       // Лёгкий след
// //       ctx.fillStyle = 'rgba(2, 8, 20, 0.35)';
// //       ctx.fillRect(0, 0, W, H);

// //       // Рисуем «провода» — тонкие линии дорожек
// //       tracks.forEach((tr) => {
// //         ctx.beginPath();
// //         for (let x = 0; x <= W; x += 4) {
// //           const y = tr.baseY + Math.sin(x * tr.freq + tr.phase) * tr.amp;
// //           if (x === 0) ctx.moveTo(x, y);
// //           else ctx.lineTo(x, y);
// //         }
// //         ctx.strokeStyle = `rgba(59, 130, 246, ${0.12 + 0.15 * power})`;
// //         ctx.lineWidth = 1;
// //         ctx.stroke();
// //       });

// //       // Обновляем и рисуем частицы
// //       tracks.forEach((tr) => {
// //         spawnTimer += dt;
// //         if (spawnTimer > 25 - power * 15 && tr.particles.length < 8) {
// //           spawnTimer = 0;
// //           if (Math.random() > 0.4) spawn(tr);
// //         }

// //         tr.particles = tr.particles.filter((pt) => pt.x < W + 40);

// //         tr.particles.forEach((pt) => {
// //           if (pt.delay > 0) {
// //             pt.delay -= dt;
// //             return;
// //           }

// //           pt.x += pt.speed * dt * (0.6 + power * 2);

// //           const y = tr.baseY + Math.sin(pt.x * tr.freq + tr.phase) * tr.amp + pt.yOffset;
// //           const alpha = 0.35 + 0.55 * power;
// //           const color = pt.size > 13 ? '#93c5fd' : '#60a5fa';

// //           ctx.save();
// //           ctx.shadowBlur = 6 + power * 6;
// //           ctx.shadowColor = '#3b82f6';
// //           drawEnvelope(pt.x, y, pt.size, 0, color, alpha);
// //           ctx.restore();
// //         });
// //       });
// //     };

// //     raf = requestAnimationFrame(draw);
// //     return () => cancelAnimationFrame(raf);
// //   }, [pRef]);

// //   return <canvas ref={ref} className="absolute inset-0 w-full h-full" aria-hidden="true" />;
// // }

// // /* ---------- MacBook ---------- */
// // function MacBook({ p, pRef }) {
// //   const sent = Math.round(easeOut(seg(p, 0.24, 0.9)) * TOTAL);
// //   const panel = seg(p, 0.2, 0.3);
// //   const delivered = Math.round(sent * 0.98);
// //   const opened = Math.round(sent * 0.46);
// //   const replies = Math.round(sent * 0.07);
// //   const log = Array.from({ length: 6 }, (_, k) => sent - k).filter((n) => n > 0);

// //   return (
// //     <div className="w-[min(90vw,920px)] mx-auto select-none">
// //       {/* крышка */}
// //       <div
// //         className="relative rounded-[22px] p-[10px] shadow-[0_40px_120px_-20px_rgba(37,99,235,0.55)]"
// //         style={{ background: 'linear-gradient(160deg,#2b2f38,#0d0f14)', border: '1px solid #3a3f4b' }}
// //       >
// //         <div className="relative rounded-[12px] overflow-hidden bg-[#020814]" style={{ aspectRatio: '16 / 10' }}>
// //           <CircuitFlow pRef={pRef} />
// //           <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[14%] h-[4%] bg-black rounded-b-lg z-20" />

// //           {/* стартовая строка */}
// //           <div
// //             className="absolute inset-0 flex items-center justify-center font-mono text-blue-300 text-sm md:text-lg z-10"
// //             style={{ opacity: 1 - seg(p, 0.1, 0.22) }}
// //           >
// //             <span>&gt; mailora --send campaign_b2b</span>
// //             <span className="ml-1 w-2 h-5 bg-blue-300 animate-pulse" />
// //           </div>

// //           {/* окно рассылки */}
// //           <div
// //             className="absolute inset-[7%] rounded-xl bg-[#0a1226]/85 backdrop-blur-md border border-blue-400/25 p-3 md:p-5 text-white z-10 flex flex-col"
// //             style={{ opacity: panel, transform: `translateY(${(1 - panel) * 24}px)` }}
// //           >
// //             <div className="flex items-center gap-1.5 mb-3">
// //               <span className="w-2.5 h-2.5 rounded-full bg-red-400" />
// //               <span className="w-2.5 h-2.5 rounded-full bg-yellow-400" />
// //               <span className="w-2.5 h-2.5 rounded-full bg-green-400" />
// //               <span className="ml-3 text-[11px] md:text-xs text-blue-200/70">Кампания «Новые клиенты Q4»</span>
// //             </div>
// //             <div className="flex items-end justify-between">
// //               <div>
// //                 <div className="text-3xl md:text-5xl font-bold tabular-nums leading-none">{sent}</div>
// //                 <div className="text-[11px] md:text-xs text-blue-200/70 mt-1">писем отправлено из {TOTAL}</div>
// //               </div>
// //               <div className="hidden sm:flex gap-5 text-right text-[11px] md:text-xs text-blue-200/70">
// //                 <div><div className="text-base md:text-lg text-white tabular-nums">{delivered}</div>доставлено</div>
// //                 <div><div className="text-base md:text-lg text-white tabular-nums">{opened}</div>открыто</div>
// //                 <div><div className="text-base md:text-lg text-emerald-300 tabular-nums">{replies}</div>ответов</div>
// //               </div>
// //             </div>
// //             <div className="h-1.5 rounded-full bg-white/10 mt-3 overflow-hidden">
// //               <div className="h-full bg-blue-500" style={{ width: `${(sent / TOTAL) * 100}%` }} />
// //             </div>
// //             <ul className="mt-3 space-y-1 font-mono text-[10px] md:text-xs overflow-hidden">
// //               {log.map((n) => (
// //                 <li key={n} className="flex justify-between text-blue-100/80">
// //                   <span className="truncate">{mail(n)}</span>
// //                   <span className="text-emerald-300 ml-3 shrink-0">отправлено</span>
// //                 </li>
// //               ))}
// //             </ul>
// //           </div>
// //         </div>
// //       </div>
// //       {/* основание */}
// //       <div
// //         className="mx-auto h-[14px] rounded-b-[18px] w-[112%] -ml-[6%] relative"
// //         style={{ background: 'linear-gradient(#c9ccd3,#8b8f98)', boxShadow: '0 20px 40px rgba(0,0,0,.5)' }}
// //       >
// //         <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[16%] h-[5px] rounded-b-md bg-[#6b6f78]" />
// //       </div>
// //     </div>
// //   );
// // }

// // /* ---------- Три основных блока ---------- */
// // const BOXES = [
// //   { m: 'sales@brand.ru', v: 96 },
// //   { m: 'ceo@brand.ru', v: 88 },
// //   { m: 'hello@brand-mail.ru', v: 61 },
// // ];
// // const STEPS = [
// //   ['День 1', 'Первое письмо с обращением по имени'],
// //   ['День 3', 'Короткое напоминание'],
// //   ['День 7', 'Последнее касание с предложением созвониться'],
// // ];
// // const REPLIES = [
// //   ['Логист-Про', 'Да, пришлите коммерческое предложение', 'новый'],
// //   ['Агрохолдинг', 'Давайте созвонимся во вторник', 'новый'],
// //   ['Промснаб', 'Сейчас не актуально, вернёмся в январе', 'прочитан'],
// // ];

// // function Panel({ children }) {
// //   return (
// //     <div className="rounded-2xl border border-blue-400/20 bg-[#0a1226] p-5 md:p-6 shadow-[0_30px_80px_-30px_rgba(37,99,235,0.5)]">
// //       {children}
// //     </div>
// //   );
// // }

// // function Row({ title, text, flip, children }) {
// //   return (
// //     <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
// //       <div className={flip ? 'md:order-2' : ''}>
// //         <h3 className="text-3xl md:text-4xl font-bold leading-tight">{title}</h3>
// //         <p className="mt-4 text-lg text-blue-100/70 max-w-[46ch]">{text}</p>
// //       </div>
// //       <div className={flip ? 'md:order-1' : ''}>{children}</div>
// //     </div>
// //   );
// // }

// // function Features() {
// //   return (
// //     <section className="relative bg-[#020814] px-4 pt-14 pb-28">
// //       <div className="max-w-6xl mx-auto space-y-28 md:space-y-36">
// //         <Row
// //           title="Письма доходят до людей, а не до спама"
// //           text="Подключите свои ящики, мы прогреем их и будем следить за репутацией. Отправка идёт понемногу с разных адресов, чтобы почтовые сервисы не считали её массовой."
// //         >
// //           <Panel>
// //             <div className="space-y-4">
// //               {BOXES.map((b) => (
// //                 <div key={b.m}>
// //                   <div className="flex justify-between text-sm">
// //                     <span className="font-mono text-blue-100">{b.m}</span>
// //                     <span className="text-blue-200/70">репутация {b.v}%</span>
// //                   </div>
// //                   <div className="h-2 rounded-full bg-white/10 mt-2 overflow-hidden">
// //                     <div
// //                       className={`h-full rounded-full ${b.v > 80 ? 'bg-emerald-400' : 'bg-amber-400'}`}
// //                       style={{ width: `${b.v}%` }}
// //                     />
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </Panel>
// //         </Row>

// //         <Row
// //           flip
// //           title="Одна цепочка вместо десяти ручных писем"
// //           text="Опишите последовательность один раз: первое письмо, напоминания, финальное касание. Когда клиент ответил, цепочка для него останавливается сама."
// //         >
// //           <Panel>
// //             <ol className="relative border-l border-blue-400/30 ml-2 space-y-5">
// //               {STEPS.map(([d, t]) => (
// //                 <li key={d} className="pl-6 relative">
// //                   <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-blue-500" />
// //                   <div className="text-sm text-blue-300">{d}</div>
// //                   <div className="text-base">{t}</div>
// //                 </li>
// //               ))}
// //               <li className="pl-6 relative">
// //                 <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-emerald-400" />
// //                 <div className="text-base text-emerald-300">Клиент ответил: цепочка остановлена</div>
// //               </li>
// //             </ol>
// //           </Panel>
// //         </Row>

// //         <Row
// //           title="Все ответы в одном месте"
// //           text="Не нужно открывать десять почтовых ящиков. Ответы клиентов собираются в одной ленте, и вы сразу видите, с кем пора говорить."
// //         >
// //           <Panel>
// //             <ul className="divide-y divide-white/10">
// //               {REPLIES.map(([n, t, s]) => (
// //                 <li key={n} className="py-3 first:pt-0 last:pb-0 flex items-start justify-between gap-4">
// //                   <div>
// //                     <div className="font-medium">{n}</div>
// //                     <div className="text-sm text-blue-100/70">{t}</div>
// //                   </div>
// //                   <span
// //                     className={`text-xs px-2 py-1 rounded-full shrink-0 ${
// //                       s === 'новый' ? 'bg-blue-500/20 text-blue-300' : 'bg-white/10 text-blue-200/60'
// //                     }`}
// //                   >
// //                     {s}
// //                   </span>
// //                 </li>
// //               ))}
// //             </ul>
// //           </Panel>
// //         </Row>
// //       </div>
// //     </section>
// //   );
// // }

// // /* ---------- Страница ---------- */
// // export default function Landing() {
// //   const { isAuthenticated, loading } = useAuth();
// //   const sceneRef = useRef(null);
// //   const pRef = useRef(0);
// //   const [p, setP] = useState(0);

// //   useEffect(() => {
// //     if (!loading && isAuthenticated && APP_URL) {
// //       window.location.href = `${APP_URL}/dashboard`;
// //     }
// //   }, [loading, isAuthenticated]);

// //   useEffect(() => {
// //     if (loading) return;
// //     let raf = 0;
// //     const update = () => {
// //       raf = 0;
// //       const el = sceneRef.current;
// //       if (!el) return;
// //       const r = el.getBoundingClientRect();
// //       const raw = clamp(-r.top / (r.height - window.innerHeight));
// //       const v = clamp(raw * 0.75);
// //       pRef.current = v;
// //       setP(v);
// //     };
// //     const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
// //     update();
// //     window.addEventListener('scroll', onScroll, { passive: true });
// //     window.addEventListener('resize', onScroll);
// //     return () => {
// //       window.removeEventListener('scroll', onScroll);
// //       window.removeEventListener('resize', onScroll);
// //       if (raf) cancelAnimationFrame(raf);
// //     };
// //   }, [loading]);

// //   if (loading) {
// //     return (
// //       <div className="min-h-screen flex items-center justify-center bg-gray-50">
// //         <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
// //       </div>
// //     );
// //   }

// //   const zoom = easeOut(seg(p, 0.05, 0.55));
// //   const tilt = lerp(28, 0, easeOut(seg(p, 0, 0.35)));
// //   const scale = lerp(0.78, 1.08, zoom);
// //   const y = lerp(40, 0, easeOut(seg(p, 0, 0.35)));
// //   const heroOpacity = 1 - seg(p, 0.05, 0.2);
// //   const cap2 = seg(p, 0.2, 0.32) * (1 - seg(p, 0.55, 0.65));
// //   const cap3 = seg(p, 0.65, 0.78);

// //   return (
// //     <div className="min-h-screen bg-[#020814] text-white">
// //       {/* Шапка */}
// //       <header className="fixed top-0 inset-x-0 z-50">
// //         <div className="max-w-6xl mx-auto px-4 py-5 flex items-center justify-between">
// //           <Link to="/" className="flex items-center gap-2 text-xl font-bold text-blue-400">
// //             <span className="w-2 h-2 rounded-full bg-blue-400 inline-block" />
// //             MAILORA
// //           </Link>
// //           <div className="flex gap-3">
// //             <Link to="/login" className="px-4 py-2 rounded-xl text-blue-100 hover:bg-white/10 transition">
// //               Войти
// //             </Link>
// //             <Link to="/register" className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-500 transition shadow-md">
// //               Регистрация
// //             </Link>
// //           </div>
// //         </div>
// //       </header>

// //       {/* Сцена со скроллом */}
// //       <section ref={sceneRef} className="relative" style={{ height: '200vh' }}>
// //         <div className="sticky top-0 h-screen overflow-hidden">
// //           <div
// //             className="absolute -left-40 top-10 w-[520px] h-[520px] rounded-full bg-blue-600/25 blur-[120px]"
// //             style={{ transform: `translateY(${p * -260}px)` }}
// //           />
// //           <div
// //             className="absolute -right-32 bottom-0 w-[460px] h-[460px] rounded-full bg-indigo-500/20 blur-[120px]"
// //             style={{ transform: `translateY(${p * 320}px)` }}
// //           />

// //           {/* заголовок первого экрана */}
// //           <div
// //             className="absolute inset-x-0 top-[13vh] px-4 text-center z-10"
// //             style={{ opacity: heroOpacity, transform: `translateY(${p * -160}px)` }}
// //           >
// //             <span className="inline-block text-xs font-semibold tracking-wider uppercase text-blue-300 bg-blue-500/15 px-3 py-1 rounded-full mb-5">
// //               Мы запустились!
// //             </span>
// //             <h1 className="text-4xl md:text-6xl font-bold leading-tight">Сервис для email рассылок</h1>
// //             <p className="mt-4 text-base md:text-lg text-blue-100/70 max-w-[56ch] mx-auto">
// //               Привлекайте новых клиентов в B2B сегменте с помощью деловой коммуникации через email переписки.
// //             </p>
// //             <Link
// //               to="/register"
// //               className="inline-block mt-7 px-6 py-3 rounded-xl bg-blue-600 text-white font-medium hover:bg-blue-500 transition shadow-lg"
// //             >
// //               Попробовать бесплатно 7 дней
// //             </Link>
// //           </div>

// //           {/* подписи по ходу скролла */}
// //           <div
// //             className="absolute inset-x-0 top-[10vh] text-center px-4 z-10 pointer-events-none"
// //             style={{ opacity: cap2 }}
// //           >
// //             <h2 className="text-2xl md:text-4xl font-bold">Одно нажатие — и код оживает</h2>
// //           </div>
// //           <div
// //             className="absolute inset-x-0 top-[10vh] text-center px-4 z-10"
// //             style={{ opacity: cap3 }}
// //           >
// //             <h2 className="text-2xl md:text-4xl font-bold">Сотни писем ушли, пока вы пили кофе</h2>
// //             <Link
// //               to="/register"
// //               className="inline-block mt-5 px-6 py-3 rounded-xl bg-blue-600 text-white font-medium hover:bg-blue-500 transition shadow-lg"
// //             >
// //               Попробовать бесплатно 7 дней
// //             </Link>
// //           </div>

// //           {/* MacBook */}
// //           <div
// //             className="absolute inset-x-0 bottom-0 z-0"
// //             style={{
// //               transform: `translateY(${y}px)`,
// //               perspective: '1600px',
// //             }}
// //           >
// //             <div style={{ transform: `rotateX(${tilt}deg) scale(${scale})`, transformOrigin: '50% 100%' }}>
// //               <MacBook p={p} pRef={pRef} />
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       <Features />

// //       {/* Футер */}
// //       <footer id="footer" className="bg-white text-gray-900 border-t border-gray-200 py-10">
// //         <div className="max-w-6xl mx-auto px-4">
// //           <div className="text-[13px] leading-relaxed text-gray-500 font-light">
// //             <div className="flex flex-wrap gap-x-6 gap-y-1">
// //               <span><span className="text-gray-400">ИП</span> Сидоренко Руслан Владимирович</span>
// //               <span><span className="text-gray-400">ИНН</span> 611300126009</span>
// //               <span><span className="text-gray-400">ОГРНИП</span> 317619600088799</span>
// //             </div>
// //           </div>
// //           <div className="border-t border-gray-200 mt-6 pt-6 text-[13px] text-gray-500 font-light">
// //             © {new Date().getFullYear()} Mailora. Все права защищены.
// //           </div>
// //         </div>
// //       </footer>

// //       <CookieBanner />
// //     </div>
// //   );
// // }

// import React, { useEffect, useRef, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { useAuth } from '../AuthContext';
// import CookieBanner from '../CookieBanner';

// const APP_URL = process.env.REACT_APP_APP_URL;

// const TOTAL = 500;
// const NAMES = ['ivanov', 'a.smirnova', 'director', 'sales', 'p.kuznetsov', 'info', 'm.orlova', 'ceo', 'zakupki', 'k.belov', 'hr', 'o.volkova'];
// const DOMAINS = ['stroytech.ru', 'logist-pro.ru', 'agroholding.ru', 'medline.ru', 'promsnab.ru', 'it-partner.ru', 'retail-group.ru', 'energo.ru'];

// const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
// const lerp = (a, b, t) => a + (b - a) * t;
// const seg = (p, a, b) => clamp((p - a) / (b - a));
// const easeOut = (t) => 1 - Math.pow(1 - t, 3);
// const mail = (i) => `${NAMES[i % NAMES.length]}@${DOMAINS[(i * 7) % DOMAINS.length]}`;

// /* ---------- Electric circuit: мелкие конверты быстро бегут по дорожкам ---------- */
// function CircuitFlow({ pRef }) {
//   const ref = useRef(null);

//   useEffect(() => {
//     const c = ref.current;
//     const ctx = c.getContext('2d');
//     const W = 640, H = 400;
//     const dpr = window.devicePixelRatio || 1;
//     c.width = W * dpr;
//     c.height = H * dpr;
//     c.style.width = '100%';
//     c.style.height = '100%';
//     ctx.scale(dpr, dpr);

//     const TRACKS = 5;
//     const tracks = Array.from({ length: TRACKS }, (_, i) => ({
//       baseY: (H / (TRACKS + 1)) * (i + 1),
//       amp: 14 + (i % 3) * 10,
//       freq: 0.008 + i * 0.003,
//       phase: i * 1.7,
//       particles: [],
//     }));

//     const drawEnvelope = (x, y, size, rotation, color, alpha) => {
//       ctx.save();
//       ctx.translate(x, y);
//       ctx.rotate(rotation);
//       ctx.globalAlpha = alpha;

//       ctx.strokeStyle = color;
//       ctx.lineWidth = 1;
//       ctx.strokeRect(-size / 2, -size * 0.7, size, size * 1.4);

//       ctx.beginPath();
//       ctx.moveTo(-size / 2, -size * 0.7);
//       ctx.lineTo(0, size * 0.15);
//       ctx.lineTo(size / 2, -size * 0.7);
//       ctx.stroke();

//       ctx.restore();
//     };

//     const spawn = (track, startX = -30) => {
//       track.particles.push({
//         x: startX,
//         yOffset: (Math.random() - 0.5) * 6,
//         size: 5 + Math.random() * 3,        // мелкие
//         speed: 1.2 + Math.random() * 1.2,   // быстрые
//         delay: Math.random() * 60,
//       });
//     };

//     tracks.forEach((t) => {
//       const count = 4 + Math.floor(Math.random() * 3);
//       for (let i = 0; i < count; i++) {
//         spawn(t, -30 - Math.random() * 200);
//       }
//     });

//     let raf, last = 0;
//     let spawnTimer = 0;

//     const draw = (t) => {
//       raf = requestAnimationFrame(draw);
//       if (t - last < 32) return;
//       const dt = (t - last) / 16;
//       last = t;

//       const p = pRef.current;
//       const power = seg(p, 0.08, 0.85);

//       ctx.fillStyle = 'rgba(2, 8, 20, 0.35)';
//       ctx.fillRect(0, 0, W, H);

//       tracks.forEach((tr) => {
//         ctx.beginPath();
//         for (let x = 0; x <= W; x += 4) {
//           const y = tr.baseY + Math.sin(x * tr.freq + tr.phase) * tr.amp;
//           if (x === 0) ctx.moveTo(x, y);
//           else ctx.lineTo(x, y);
//         }
//         ctx.strokeStyle = `rgba(59, 130, 246, ${0.12 + 0.15 * power})`;
//         ctx.lineWidth = 1;
//         ctx.stroke();
//       });

//       tracks.forEach((tr) => {
//         spawnTimer += dt;
//         if (spawnTimer > 12 - power * 8 && tr.particles.length < 12) {
//           spawnTimer = 0;
//           if (Math.random() > 0.4) spawn(tr);
//         }

//         tr.particles = tr.particles.filter((pt) => pt.x < W + 40);

//         tr.particles.forEach((pt) => {
//           if (pt.delay > 0) {
//             pt.delay -= dt;
//             return;
//           }

//           pt.x += pt.speed * dt * (1.2 + power * 4);   // ×2 скорость

//           const y = tr.baseY + Math.sin(pt.x * tr.freq + tr.phase) * tr.amp + pt.yOffset;
//           const alpha = 0.35 + 0.55 * power;
//           const color = pt.size > 6.5 ? '#93c5fd' : '#60a5fa';

//           ctx.save();
//           ctx.shadowBlur = 3 + power * 3;
//           ctx.shadowColor = '#3b82f6';
//           drawEnvelope(pt.x, y, pt.size, 0, color, alpha);
//           ctx.restore();
//         });
//       });
//     };

//     raf = requestAnimationFrame(draw);
//     return () => cancelAnimationFrame(raf);
//   }, [pRef]);

//   return <canvas ref={ref} className="absolute inset-0 w-full h-full" aria-hidden="true" />;
// }

// /* ---------- MacBook ---------- */
// function MacBook({ p, pRef }) {
//   const sent = Math.round(easeOut(seg(p, 0.12, 0.7)) * TOTAL);   // раньше стартует
//   const panel = seg(p, 0.1, 0.2);                                 // раньше появляется
//   const delivered = Math.round(sent * 0.98);
//   const opened = Math.round(sent * 0.46);
//   const replies = Math.round(sent * 0.07);
//   const log = Array.from({ length: 6 }, (_, k) => sent - k).filter((n) => n > 0);

//   return (
//     <div className="w-[min(90vw,920px)] mx-auto select-none">
//       <div
//         className="relative rounded-[22px] p-[10px] shadow-[0_40px_120px_-20px_rgba(37,99,235,0.55)]"
//         style={{ background: 'linear-gradient(160deg,#2b2f38,#0d0f14)', border: '1px solid #3a3f4b' }}
//       >
//         <div className="relative rounded-[12px] overflow-hidden bg-[#020814]" style={{ aspectRatio: '16 / 10' }}>
//           <CircuitFlow pRef={pRef} />
//           <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[14%] h-[4%] bg-black rounded-b-lg z-20" />

//           {/* стартовая строка — уходит быстрее */}
//           <div
//             className="absolute inset-0 flex items-center justify-center font-mono text-blue-300 text-sm md:text-lg z-10"
//             style={{ opacity: 1 - seg(p, 0.05, 0.14) }}
//           >
//             <span>&gt; mailora --send campaign_b2b</span>
//             <span className="ml-1 w-2 h-5 bg-blue-300 animate-pulse" />
//           </div>

//           {/* окно рассылки */}
//           <div
//             className="absolute inset-[7%] rounded-xl bg-[#0a1226]/85 backdrop-blur-md border border-blue-400/25 p-3 md:p-5 text-white z-10 flex flex-col"
//             style={{ opacity: panel, transform: `translateY(${(1 - panel) * 24}px)` }}
//           >
//             <div className="flex items-center gap-1.5 mb-3">
//               <span className="w-2.5 h-2.5 rounded-full bg-red-400" />
//               <span className="w-2.5 h-2.5 rounded-full bg-yellow-400" />
//               <span className="w-2.5 h-2.5 rounded-full bg-green-400" />
//               <span className="ml-3 text-[11px] md:text-xs text-blue-200/70">Кампания «Новые клиенты Q4»</span>
//             </div>
//             <div className="flex items-end justify-between">
//               <div>
//                 <div className="text-3xl md:text-5xl font-bold tabular-nums leading-none">{sent}</div>
//                 <div className="text-[11px] md:text-xs text-blue-200/70 mt-1">писем отправлено из {TOTAL}</div>
//               </div>
//               <div className="hidden sm:flex gap-5 text-right text-[11px] md:text-xs text-blue-200/70">
//                 <div><div className="text-base md:text-lg text-white tabular-nums">{delivered}</div>доставлено</div>
//                 <div><div className="text-base md:text-lg text-white tabular-nums">{opened}</div>открыто</div>
//                 <div><div className="text-base md:text-lg text-emerald-300 tabular-nums">{replies}</div>ответов</div>
//               </div>
//             </div>
//             <div className="h-1.5 rounded-full bg-white/10 mt-3 overflow-hidden">
//               <div className="h-full bg-blue-500" style={{ width: `${(sent / TOTAL) * 100}%` }} />
//             </div>
//             <ul className="mt-3 space-y-1 font-mono text-[10px] md:text-xs overflow-hidden">
//               {log.map((n) => (
//                 <li key={n} className="flex justify-between text-blue-100/80">
//                   <span className="truncate">{mail(n)}</span>
//                   <span className="text-emerald-300 ml-3 shrink-0">отправлено</span>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//       </div>
//       <div
//         className="mx-auto h-[14px] rounded-b-[18px] w-[112%] -ml-[6%] relative"
//         style={{ background: 'linear-gradient(#c9ccd3,#8b8f98)', boxShadow: '0 20px 40px rgba(0,0,0,.5)' }}
//       >
//         <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[16%] h-[5px] rounded-b-md bg-[#6b6f78]" />
//       </div>
//     </div>
//   );
// }

// /* ---------- Три основных блока ---------- */
// const BOXES = [
//   { m: 'sales@brand.ru', v: 96 },
//   { m: 'ceo@brand.ru', v: 88 },
//   { m: 'hello@brand-mail.ru', v: 61 },
// ];
// const STEPS = [
//   ['День 1', 'Первое письмо с обращением по имени'],
//   ['День 3', 'Короткое напоминание'],
//   ['День 7', 'Последнее касание с предложением созвониться'],
// ];
// const REPLIES = [
//   ['Логист-Про', 'Да, пришлите коммерческое предложение', 'новый'],
//   ['Агрохолдинг', 'Давайте созвонимся во вторник', 'новый'],
//   ['Промснаб', 'Сейчас не актуально, вернёмся в январе', 'прочитан'],
// ];

// function Panel({ children }) {
//   return (
//     <div className="rounded-2xl border border-blue-400/20 bg-[#0a1226] p-5 md:p-6 shadow-[0_30px_80px_-30px_rgba(37,99,235,0.5)]">
//       {children}
//     </div>
//   );
// }

// function Row({ title, text, flip, children }) {
//   return (
//     <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
//       <div className={flip ? 'md:order-2' : ''}>
//         <h3 className="text-3xl md:text-4xl font-bold leading-tight">{title}</h3>
//         <p className="mt-4 text-lg text-blue-100/70 max-w-[46ch]">{text}</p>
//       </div>
//       <div className={flip ? 'md:order-1' : ''}>{children}</div>
//     </div>
//   );
// }

// function Features() {
//   return (
//     <section className="relative bg-[#020814] px-4 pt-14 pb-28">
//       <div className="max-w-6xl mx-auto space-y-28 md:space-y-36">
//         <Row
//           title="Письма доходят до людей, а не до спама"
//           text="Подключите свои ящики, мы прогреем их и будем следить за репутацией. Отправка идёт понемногу с разных адресов, чтобы почтовые сервисы не считали её массовой."
//         >
//           <Panel>
//             <div className="space-y-4">
//               {BOXES.map((b) => (
//                 <div key={b.m}>
//                   <div className="flex justify-between text-sm">
//                     <span className="font-mono text-blue-100">{b.m}</span>
//                     <span className="text-blue-200/70">репутация {b.v}%</span>
//                   </div>
//                   <div className="h-2 rounded-full bg-white/10 mt-2 overflow-hidden">
//                     <div
//                       className={`h-full rounded-full ${b.v > 80 ? 'bg-emerald-400' : 'bg-amber-400'}`}
//                       style={{ width: `${b.v}%` }}
//                     />
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </Panel>
//         </Row>

//         <Row
//           flip
//           title="Одна цепочка вместо десяти ручных писем"
//           text="Опишите последовательность один раз: первое письмо, напоминания, финальное касание. Когда клиент ответил, цепочка для него останавливается сама."
//         >
//           <Panel>
//             <ol className="relative border-l border-blue-400/30 ml-2 space-y-5">
//               {STEPS.map(([d, t]) => (
//                 <li key={d} className="pl-6 relative">
//                   <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-blue-500" />
//                   <div className="text-sm text-blue-300">{d}</div>
//                   <div className="text-base">{t}</div>
//                 </li>
//               ))}
//               <li className="pl-6 relative">
//                 <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-emerald-400" />
//                 <div className="text-base text-emerald-300">Клиент ответил: цепочка остановлена</div>
//               </li>
//             </ol>
//           </Panel>
//         </Row>

//         <Row
//           title="Все ответы в одном месте"
//           text="Не нужно открывать десять почтовых ящиков. Ответы клиентов собираются в одной ленте, и вы сразу видите, с кем пора говорить."
//         >
//           <Panel>
//             <ul className="divide-y divide-white/10">
//               {REPLIES.map(([n, t, s]) => (
//                 <li key={n} className="py-3 first:pt-0 last:pb-0 flex items-start justify-between gap-4">
//                   <div>
//                     <div className="font-medium">{n}</div>
//                     <div className="text-sm text-blue-100/70">{t}</div>
//                   </div>
//                   <span
//                     className={`text-xs px-2 py-1 rounded-full shrink-0 ${
//                       s === 'новый' ? 'bg-blue-500/20 text-blue-300' : 'bg-white/10 text-blue-200/60'
//                     }`}
//                   >
//                     {s}
//                   </span>
//                 </li>
//               ))}
//             </ul>
//           </Panel>
//         </Row>
//       </div>
//     </section>
//   );
// }

// /* ---------- Страница ---------- */
// export default function Landing() {
//   const { isAuthenticated, loading } = useAuth();
//   const sceneRef = useRef(null);
//   const pRef = useRef(0);
//   const [p, setP] = useState(0);

//   useEffect(() => {
//     if (!loading && isAuthenticated && APP_URL) {
//       window.location.href = `${APP_URL}/dashboard`;
//     }
//   }, [loading, isAuthenticated]);

//   useEffect(() => {
//     if (loading) return;
//     let raf = 0;
//     const update = () => {
//       raf = 0;
//       const el = sceneRef.current;
//       if (!el) return;
//       const r = el.getBoundingClientRect();
//       const raw = clamp(-r.top / (r.height - window.innerHeight));
//       const v = clamp(raw * 0.75);
//       pRef.current = v;
//       setP(v);
//     };
//     const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
//     update();
//     window.addEventListener('scroll', onScroll, { passive: true });
//     window.addEventListener('resize', onScroll);
//     return () => {
//       window.removeEventListener('scroll', onScroll);
//       window.removeEventListener('resize', onScroll);
//       if (raf) cancelAnimationFrame(raf);
//     };
//   }, [loading]);

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50">
//         <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
//       </div>
//     );
//   }

//   const zoom = easeOut(seg(p, 0.05, 0.55));
//   const tilt = lerp(28, 0, easeOut(seg(p, 0, 0.35)));
//   const scale = lerp(0.78, 1.08, zoom);
//   const y = lerp(40, 0, easeOut(seg(p, 0, 0.35)));
//   const heroOpacity = 1 - seg(p, 0.03, 0.14);
//   const cap2 = seg(p, 0.2, 0.32) * (1 - seg(p, 0.55, 0.65));
//   const cap3 = seg(p, 0.65, 0.78);

//   return (
//     <div className="min-h-screen bg-[#020814] text-white">
//       <header className="fixed top-0 inset-x-0 z-50">
//         <div className="max-w-6xl mx-auto px-4 py-5 flex items-center justify-between">
//           <Link to="/" className="flex items-center gap-2 text-xl font-bold text-blue-400">
//             <span className="w-2 h-2 rounded-full bg-blue-400 inline-block" />
//             MAILORA
//           </Link>
//           <div className="flex gap-3">
//             <Link to="/login" className="px-4 py-2 rounded-xl text-blue-100 hover:bg-white/10 transition">
//               Войти
//             </Link>
//             <Link to="/register" className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-500 transition shadow-md">
//               Регистрация
//             </Link>
//           </div>
//         </div>
//       </header>

//       <section ref={sceneRef} className="relative" style={{ height: '200vh' }}>
//         <div className="sticky top-0 h-screen overflow-hidden">
//           <div
//             className="absolute -left-40 top-10 w-[520px] h-[520px] rounded-full bg-blue-600/25 blur-[120px]"
//             style={{ transform: `translateY(${p * -260}px)` }}
//           />
//           <div
//             className="absolute -right-32 bottom-0 w-[460px] h-[460px] rounded-full bg-indigo-500/20 blur-[120px]"
//             style={{ transform: `translateY(${p * 320}px)` }}
//           />

//           <div
//             className="absolute inset-x-0 top-[13vh] px-4 text-center z-10"
//             style={{ opacity: heroOpacity, transform: `translateY(${p * -160}px)` }}
//           >
//             <span className="inline-block text-xs font-semibold tracking-wider uppercase text-blue-300 bg-blue-500/15 px-3 py-1 rounded-full mb-5">
//               Мы запустились!
//             </span>
//             <h1 className="text-4xl md:text-6xl font-bold leading-tight">Сервис для email рассылок</h1>
//             <p className="mt-4 text-base md:text-lg text-blue-100/70 max-w-[56ch] mx-auto">
//               Привлекайте новых клиентов в B2B сегменте с помощью деловой коммуникации через email переписки.
//             </p>
//             <Link
//               to="/register"
//               className="inline-block mt-7 px-6 py-3 rounded-xl bg-blue-600 text-white font-medium hover:bg-blue-500 transition shadow-lg"
//             >
//               Попробовать бесплатно 7 дней
//             </Link>
//           </div>

//           <div
//             className="absolute inset-x-0 top-[10vh] text-center px-4 z-10 pointer-events-none"
//             style={{ opacity: cap2 }}
//           >
//             <h2 className="text-2xl md:text-4xl font-bold">Одно нажатие — и код оживает</h2>
//           </div>
//           <div
//             className="absolute inset-x-0 top-[10vh] text-center px-4 z-10"
//             style={{ opacity: cap3 }}
//           >
//             <h2 className="text-2xl md:text-4xl font-bold">Сотни писем ушли, пока вы пили кофе</h2>
//             <Link
//               to="/register"
//               className="inline-block mt-5 px-6 py-3 rounded-xl bg-blue-600 text-white font-medium hover:bg-blue-500 transition shadow-lg"
//             >
//               Попробовать бесплатно 7 дней
//             </Link>
//           </div>

//           <div
//             className="absolute inset-x-0 bottom-0 z-0"
//             style={{
//               transform: `translateY(${y}px)`,
//               perspective: '1600px',
//             }}
//           >
//             <div style={{ transform: `rotateX(${tilt}deg) scale(${scale})`, transformOrigin: '50% 100%' }}>
//               <MacBook p={p} pRef={pRef} />
//             </div>
//           </div>
//         </div>
//       </section>

//       <Features />

//       <footer id="footer" className="bg-white text-gray-900 border-t border-gray-200 py-10">
//         <div className="max-w-6xl mx-auto px-4">
//           <div className="text-[13px] leading-relaxed text-gray-500 font-light">
//             <div className="flex flex-wrap gap-x-6 gap-y-1">
//               <span><span className="text-gray-400">ИП</span> Сидоренко Руслан Владимирович</span>
//               <span><span className="text-gray-400">ИНН</span> 611300126009</span>
//               <span><span className="text-gray-400">ОГРНИП</span> 317619600088799</span>
//             </div>
//           </div>
//           <div className="border-t border-gray-200 mt-6 pt-6 text-[13px] text-gray-500 font-light">
//             © {new Date().getFullYear()} Mailora. Все права защищены.
//           </div>
//         </div>
//       </footer>

//       <CookieBanner />
//     </div>
//   );
// }


//работающий код с матрицей и открывающимся компом
// import React, { useEffect, useRef, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { useAuth } from '../AuthContext';
// import CookieBanner from '../CookieBanner';
// import {
//   LayoutDashboard, Target, HelpCircle, Mail, Send,
//   MessageSquare, FileText, FolderOpen, CreditCard, Settings
// } from 'lucide-react';

// const APP_URL = process.env.REACT_APP_APP_URL;

// const TOTAL = 500;
// const NAMES = ['ivanov', 'a.smirnova', 'director', 'sales', 'p.kuznetsov', 'info', 'm.orlova', 'ceo', 'zakupki', 'k.belov', 'hr', 'o.volkova'];
// const DOMAINS = ['stroytech.ru', 'logist-pro.ru', 'agroholding.ru', 'medline.ru', 'promsnab.ru', 'it-partner.ru', 'retail-group.ru', 'energo.ru'];

// const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
// const lerp = (a, b, t) => a + (b - a) * t;
// const seg = (p, a, b) => clamp((p - a) / (b - a));
// const easeOut = (t) => 1 - Math.pow(1 - t, 3);
// const mail = (i) => `${NAMES[i % NAMES.length]}@${DOMAINS[(i * 7) % DOMAINS.length]}`;

// /* ---------- Electric circuit: мелкие конверты быстро бегут по дорожкам ---------- */
// function CircuitFlow({ pRef }) {
//   const ref = useRef(null);

//   useEffect(() => {
//     const c = ref.current;
//     const ctx = c.getContext('2d');
//     const W = 640, H = 400;
//     const dpr = window.devicePixelRatio || 1;
//     c.width = W * dpr;
//     c.height = H * dpr;
//     c.style.width = '100%';
//     c.style.height = '100%';
//     ctx.scale(dpr, dpr);

//     const TRACKS = 5;
//     const tracks = Array.from({ length: TRACKS }, (_, i) => ({
//       baseY: (H / (TRACKS + 1)) * (i + 1),
//       amp: 14 + (i % 3) * 10,
//       freq: 0.008 + i * 0.003,
//       phase: i * 1.7,
//       particles: [],
//     }));

//     const drawEnvelope = (x, y, size, rotation, color, alpha) => {
//       ctx.save();
//       ctx.translate(x, y);
//       ctx.rotate(rotation);
//       ctx.globalAlpha = alpha;

//       ctx.strokeStyle = color;
//       ctx.lineWidth = 1;
//       ctx.strokeRect(-size / 2, -size * 0.7, size, size * 1.4);

//       ctx.beginPath();
//       ctx.moveTo(-size / 2, -size * 0.7);
//       ctx.lineTo(0, size * 0.15);
//       ctx.lineTo(size / 2, -size * 0.7);
//       ctx.stroke();

//       ctx.restore();
//     };

//     const spawn = (track, startX = -30) => {
//       track.particles.push({
//         x: startX,
//         yOffset: (Math.random() - 0.5) * 6,
//         size: 5 + Math.random() * 3,
//         speed: 1.2 + Math.random() * 1.2,
//         delay: Math.random() * 60,
//       });
//     };

//     tracks.forEach((t) => {
//       const count = 4 + Math.floor(Math.random() * 3);
//       for (let i = 0; i < count; i++) {
//         spawn(t, -30 - Math.random() * 200);
//       }
//     });

//     let raf, last = 0;
//     let spawnTimer = 0;

//     const draw = (t) => {
//       raf = requestAnimationFrame(draw);
//       if (t - last < 32) return;
//       const dt = (t - last) / 16;
//       last = t;

//       const p = pRef.current;
//       const power = seg(p, 0.08, 0.85);

//       // Светлый след — под фон кабинета
//       ctx.fillStyle = 'rgba(249, 250, 251, 0.35)';
//       ctx.fillRect(0, 0, W, H);

//       // «Провода» — светло-серые
//       tracks.forEach((tr) => {
//         ctx.beginPath();
//         for (let x = 0; x <= W; x += 4) {
//           const y = tr.baseY + Math.sin(x * tr.freq + tr.phase) * tr.amp;
//           if (x === 0) ctx.moveTo(x, y);
//           else ctx.lineTo(x, y);
//         }
//         ctx.strokeStyle = `rgba(148, 163, 184, ${0.2 + 0.25 * power})`;
//         ctx.lineWidth = 1;
//         ctx.stroke();
//       });

//       // Частицы
//       tracks.forEach((tr) => {
//         spawnTimer += dt;
//         if (spawnTimer > 12 - power * 8 && tr.particles.length < 12) {
//           spawnTimer = 0;
//           if (Math.random() > 0.4) spawn(tr);
//         }

//         tr.particles = tr.particles.filter((pt) => pt.x < W + 40);

//         tr.particles.forEach((pt) => {
//           if (pt.delay > 0) {
//             pt.delay -= dt;
//             return;
//           }

//           pt.x += pt.speed * dt * (1.2 + power * 4);

//           const y = tr.baseY + Math.sin(pt.x * tr.freq + tr.phase) * tr.amp + pt.yOffset;
//           const alpha = 0.45 + 0.5 * power;
//           const color = pt.size > 6.5 ? '#2563eb' : '#60a5fa';

//           ctx.save();
//           ctx.shadowBlur = 4 + power * 3;
//           ctx.shadowColor = '#2563eb';
//           drawEnvelope(pt.x, y, pt.size, 0, color, alpha);
//           ctx.restore();
//         });
//       });
//     };

//     raf = requestAnimationFrame(draw);
//     return () => cancelAnimationFrame(raf);
//   }, [pRef]);

//   return <canvas ref={ref} className="absolute inset-0 w-full h-full" aria-hidden="true" />;
// }

// /* ---------- Сайдбар как в реальном кабинете ---------- */
// const SIDEBAR_ITEMS = [
//   { id: 'dashboard', label: 'Дашборд',    Icon: LayoutDashboard },
//   { id: 'leads',     label: 'Лиды',       Icon: Target },
//   { id: 'help',      label: 'Помощь',     Icon: HelpCircle },
//   { id: 'smtp',      label: 'Почты',      Icon: Mail },
//   { id: 'massmail',  label: 'Рассылки',   Icon: Send, active: true },
//   { id: 'conv',      label: 'Переписки',  Icon: MessageSquare },
//   { id: 'templates', label: 'Шаблоны',    Icon: FileText },
//   { id: 'catalog',   label: 'Каталог',    Icon: FolderOpen },
//   { id: 'pricing',   label: 'Тарифы',     Icon: CreditCard },
//   { id: 'settings',  label: 'Настройки',  Icon: Settings },
// ];

// function CabinetSidebar() {
//   return (
//     <aside className="w-[18%] min-w-[110px] shrink-0 bg-white border-r border-gray-200 flex flex-col py-3 px-2 text-gray-700">
//       {/* Логотип */}
//       <div className="text-blue-600 font-bold text-sm md:text-base px-2 mb-4">
//         Mailora
//       </div>

//       {/* Пункты меню */}
//       <nav className="flex-1 space-y-0.5 overflow-hidden">
//         {SIDEBAR_ITEMS.map((it) => {
//           const Icon = it.Icon;
//           return (
//             <div
//               key={it.id}
//               className={`flex items-center gap-2 px-2 py-1.5 rounded-md text-[10px] md:text-xs ${
//                 it.active
//                   ? 'bg-blue-50 text-blue-600 font-semibold'
//                   : 'text-gray-600'
//               }`}
//             >
//               <Icon size={12} className="shrink-0" />
//               <span className="truncate">{it.label}</span>
//             </div>
//           );
//         })}
//       </nav>

//       {/* Кнопка выйти */}
//       <div className="mt-2 px-2 py-1.5 rounded-md text-[10px] md:text-xs text-red-500 bg-red-50 text-center font-medium">
//         Выйти
//       </div>
//     </aside>
//   );
// }

// /* ---------- MacBook с реальным интерфейсом кабинета ---------- */
// function MacBook({ p, pRef }) {
//   const sent = Math.round(easeOut(seg(p, 0.12, 0.7)) * TOTAL);
//   const panel = seg(p, 0.1, 0.2);
//   const delivered = Math.round(sent * 0.98);
//   const opened = Math.round(sent * 0.46);
//   const replies = Math.round(sent * 0.07);

//   const campaigns = [
//     { id: 281, name: 'Прогрев отели 28.09',           status: 'Завершена' },
//     { id: 280, name: 'поиск лидов по букам в Спб 2',  status: 'Завершена' },
//     { id: 279, name: 'поиск лидов по букам в Волгограде 28.09', status: 'Завершена', active: true },
//   ];

//   const smtpRows = [
//     { email: 'svetlana.r@mailora.ru', today: 4, total: 301 },
//     { email: 'ruslan.v@mailora.ru',   today: 3, total: 266 },
//     { email: 'ivan.s@mailora.ru',     today: 5, total: 267 },
//     { email: 'olga.w@mailora.ru',     today: 4, total: 309 },
//   ];

//   const log = Array.from({ length: 4 }, (_, k) => sent - k).filter((n) => n > 0);

//   return (
//     <div className="w-[min(90vw,920px)] mx-auto select-none">
//       <div
//         className="relative rounded-[22px] p-[10px] shadow-[0_40px_120px_-20px_rgba(37,99,235,0.55)]"
//         style={{ background: 'linear-gradient(160deg,#2b2f38,#0d0f14)', border: '1px solid #3a3f4b' }}
//       >
//         <div
//           className="relative rounded-[12px] overflow-hidden bg-gray-50"
//           style={{ aspectRatio: '16 / 10' }}
//         >
//           {/* Фон с бегущими конвертами */}
//           <CircuitFlow pRef={pRef} />

//           {/* Вырез камеры */}
//           <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[14%] h-[4%] bg-black rounded-b-lg z-30" />

//           {/* Стартовая строка — уходит быстро */}
//           <div
//             className="absolute inset-0 flex items-center justify-center font-mono text-blue-700 text-xs md:text-base z-20 bg-gray-50/90"
//             style={{ opacity: 1 - seg(p, 0.05, 0.14), pointerEvents: 'none' }}
//           >
//             <span>&gt; mailora --send campaign_b2b</span>
//             <span className="ml-1 w-1.5 h-4 bg-blue-500 animate-pulse" />
//           </div>

//           {/* ИНТЕРФЕЙС КАБИНЕТА */}
//           <div
//             className="absolute inset-0 flex z-10"
//             style={{ opacity: panel }}
//           >
//             <CabinetSidebar />

//             {/* Основная область */}
//             <main className="flex-1 bg-gray-50 p-2 md:p-3 overflow-hidden flex flex-col gap-2">
//               {/* Хедер с заголовком «Выберите почты для рассылок» */}
//               <div className="flex items-center justify-between">
//                 <h3 className="text-[10px] md:text-sm font-bold text-gray-800">
//                   Выберите почты для рассылок
//                 </h3>
//                 <div className="text-[9px] md:text-[10px] text-gray-400">Обновлено: сейчас</div>
//               </div>

//               {/* SMTP-таблица */}
//               <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
//                 <div className="grid grid-cols-[1fr_60px_60px] gap-1 px-2 py-1 bg-gray-50 text-[8px] md:text-[10px] font-semibold text-gray-500 uppercase">
//                   <div>Email</div>
//                   <div className="text-right">Сегодня</div>
//                   <div className="text-right">Всего</div>
//                 </div>
//                 {smtpRows.map((r) => (
//                   <div
//                     key={r.email}
//                     className="grid grid-cols-[1fr_60px_60px] gap-1 px-2 py-1 text-[9px] md:text-[11px] border-t border-gray-100"
//                   >
//                     <div className="text-gray-800 truncate">{r.email}</div>
//                     <div className="text-right text-gray-600 tabular-nums">{r.today}</div>
//                     <div className="text-right text-gray-600 tabular-nums">{r.total}</div>
//                   </div>
//                 ))}
//               </div>

//               {/* Все кампании */}
//               <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-2 flex-1 min-h-0">
//                 <div className="text-[10px] md:text-xs font-bold text-gray-800 mb-1.5">
//                   Все кампании
//                 </div>
//                 <div className="space-y-1">
//                   {campaigns.map((c) => (
//                     <div
//                       key={c.id}
//                       className={`px-2 py-1 rounded-md border text-[9px] md:text-[11px] ${
//                         c.active
//                           ? 'border-blue-500 bg-blue-50'
//                           : 'border-gray-200 bg-white'
//                       }`}
//                     >
//                       <div className="font-semibold text-gray-800 truncate">
//                         #{c.id} — {c.name}
//                       </div>
//                       <div className="text-[8px] md:text-[10px] text-emerald-600 flex items-center gap-1 mt-0.5">
//                         <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 inline-block" />
//                         {c.status}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Детали кампании с прогрессом */}
//               <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-2">
//                 <div className="text-[10px] md:text-xs font-bold text-gray-800 mb-1">
//                   Детали #279
//                 </div>
//                 <div className="text-[8px] md:text-[10px] text-gray-600 mb-1 flex items-center gap-1">
//                   <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 inline-block" />
//                   Статус: Завершена
//                 </div>
//                 <div className="h-1.5 rounded-full bg-gray-100 overflow-hidden">
//                   <div
//                     className="h-full bg-blue-500 transition-[width] duration-300"
//                     style={{ width: `${(sent / TOTAL) * 100}%` }}
//                   />
//                 </div>
//                 <div className="mt-1 text-[8px] md:text-[10px] text-gray-500 flex justify-between">
//                   <span>
//                     <b className="text-gray-800 tabular-nums">{sent}</b> отправлено
//                     {' · '}
//                     <b className="text-gray-800 tabular-nums">{delivered}</b> доставлено
//                     {' · '}
//                     <b className="text-emerald-600 tabular-nums">{replies}</b> ответов
//                   </span>
//                   <span className="text-gray-400">из {TOTAL}</span>
//                 </div>

//                 {/* Лог отправки */}
//                 <div className="mt-1.5 font-mono text-[8px] md:text-[10px] text-gray-600 space-y-0.5">
//                   {log.map((n) => (
//                     <div key={n} className="flex justify-between">
//                       <span className="truncate">{mail(n)}</span>
//                       <span className="text-emerald-600 ml-2 shrink-0">отправлено</span>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </main>
//           </div>
//         </div>
//       </div>

//       {/* Основание */}
//       <div
//         className="mx-auto h-[14px] rounded-b-[18px] w-[112%] -ml-[6%] relative"
//         style={{ background: 'linear-gradient(#c9ccd3,#8b8f98)', boxShadow: '0 20px 40px rgba(0,0,0,.5)' }}
//       >
//         <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[16%] h-[5px] rounded-b-md bg-[#6b6f78]" />
//       </div>
//     </div>
//   );
// }

// /* ---------- Три блока преимуществ ---------- */
// const BOXES = [
//   { m: 'sales@brand.ru', v: 96 },
//   { m: 'ceo@brand.ru', v: 88 },
//   { m: 'hello@brand-mail.ru', v: 61 },
// ];
// const STEPS = [
//   ['День 1', 'Первое письмо с обращением по имени'],
//   ['День 3', 'Короткое напоминание'],
//   ['День 7', 'Последнее касание с предложением созвониться'],
// ];
// const REPLIES = [
//   ['Логист-Про', 'Да, пришлите коммерческое предложение', 'новый'],
//   ['Агрохолдинг', 'Давайте созвонимся во вторник', 'новый'],
//   ['Промснаб', 'Сейчас не актуально, вернёмся в январе', 'прочитан'],
// ];

// function Panel({ children }) {
//   return (
//     <div className="rounded-2xl border border-blue-400/20 bg-[#0a1226] p-5 md:p-6 shadow-[0_30px_80px_-30px_rgba(37,99,235,0.5)]">
//       {children}
//     </div>
//   );
// }

// function Row({ title, text, flip, children }) {
//   return (
//     <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
//       <div className={flip ? 'md:order-2' : ''}>
//         <h3 className="text-3xl md:text-4xl font-bold leading-tight">{title}</h3>
//         <p className="mt-4 text-lg text-blue-100/70 max-w-[46ch]">{text}</p>
//       </div>
//       <div className={flip ? 'md:order-1' : ''}>{children}</div>
//     </div>
//   );
// }

// function Features() {
//   return (
//     <section className="relative bg-[#020814] px-4 pt-14 pb-28">
//       <div className="max-w-6xl mx-auto space-y-28 md:space-y-36">
//         <Row
//           title="Письма доходят до людей, а не до спама"
//           text="Подключите свои ящики, мы прогреем их и будем следить за репутацией. Отправка идёт понемногу с разных адресов, чтобы почтовые сервисы не считали её массовой."
//         >
//           <Panel>
//             <div className="space-y-4">
//               {BOXES.map((b) => (
//                 <div key={b.m}>
//                   <div className="flex justify-between text-sm">
//                     <span className="font-mono text-blue-100">{b.m}</span>
//                     <span className="text-blue-200/70">репутация {b.v}%</span>
//                   </div>
//                   <div className="h-2 rounded-full bg-white/10 mt-2 overflow-hidden">
//                     <div
//                       className={`h-full rounded-full ${b.v > 80 ? 'bg-emerald-400' : 'bg-amber-400'}`}
//                       style={{ width: `${b.v}%` }}
//                     />
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </Panel>
//         </Row>

//         <Row
//           flip
//           title="Одна цепочка вместо десяти ручных писем"
//           text="Опишите последовательность один раз: первое письмо, напоминания, финальное касание. Когда клиент ответил, цепочка для него останавливается сама."
//         >
//           <Panel>
//             <ol className="relative border-l border-blue-400/30 ml-2 space-y-5">
//               {STEPS.map(([d, t]) => (
//                 <li key={d} className="pl-6 relative">
//                   <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-blue-500" />
//                   <div className="text-sm text-blue-300">{d}</div>
//                   <div className="text-base">{t}</div>
//                 </li>
//               ))}
//               <li className="pl-6 relative">
//                 <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-emerald-400" />
//                 <div className="text-base text-emerald-300">Клиент ответил: цепочка остановлена</div>
//               </li>
//             </ol>
//           </Panel>
//         </Row>

//         <Row
//           title="Все ответы в одном месте"
//           text="Не нужно открывать десять почтовых ящиков. Ответы клиентов собираются в одной ленте, и вы сразу видите, с кем пора говорить."
//         >
//           <Panel>
//             <ul className="divide-y divide-white/10">
//               {REPLIES.map(([n, t, s]) => (
//                 <li key={n} className="py-3 first:pt-0 last:pb-0 flex items-start justify-between gap-4">
//                   <div>
//                     <div className="font-medium">{n}</div>
//                     <div className="text-sm text-blue-100/70">{t}</div>
//                   </div>
//                   <span
//                     className={`text-xs px-2 py-1 rounded-full shrink-0 ${
//                       s === 'новый' ? 'bg-blue-500/20 text-blue-300' : 'bg-white/10 text-blue-200/60'
//                     }`}
//                   >
//                     {s}
//                   </span>
//                 </li>
//               ))}
//             </ul>
//           </Panel>
//         </Row>
//       </div>
//     </section>
//   );
// }

// /* ---------- Страница ---------- */
// export default function Landing() {
//   const { isAuthenticated, loading } = useAuth();
//   const sceneRef = useRef(null);
//   const pRef = useRef(0);
//   const [p, setP] = useState(0);

//   useEffect(() => {
//     if (!loading && isAuthenticated && APP_URL) {
//       window.location.href = `${APP_URL}/dashboard`;
//     }
//   }, [loading, isAuthenticated]);

//   useEffect(() => {
//     if (loading) return;
//     let raf = 0;
//     const update = () => {
//       raf = 0;
//       const el = sceneRef.current;
//       if (!el) return;
//       const r = el.getBoundingClientRect();
//       const raw = clamp(-r.top / (r.height - window.innerHeight));
//       const v = clamp(raw * 0.75);
//       pRef.current = v;
//       setP(v);
//     };
//     const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
//     update();
//     window.addEventListener('scroll', onScroll, { passive: true });
//     window.addEventListener('resize', onScroll);
//     return () => {
//       window.removeEventListener('scroll', onScroll);
//       window.removeEventListener('resize', onScroll);
//       if (raf) cancelAnimationFrame(raf);
//     };
//   }, [loading]);

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50">
//         <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
//       </div>
//     );
//   }

//   const zoom = easeOut(seg(p, 0.05, 0.55));
//   const tilt = lerp(28, 0, easeOut(seg(p, 0, 0.35)));
//   const scale = lerp(0.78, 1.08, zoom);
//   const y = lerp(40, 0, easeOut(seg(p, 0, 0.35)));
//   const heroOpacity = 1 - seg(p, 0.03, 0.14);
//   const cap2 = seg(p, 0.2, 0.32) * (1 - seg(p, 0.55, 0.65));
//   const cap3 = seg(p, 0.65, 0.78);

//   return (
//     <div className="min-h-screen bg-[#020814] text-white">
//       <header className="fixed top-0 inset-x-0 z-50">
//         <div className="max-w-6xl mx-auto px-4 py-5 flex items-center justify-between">
//           <Link to="/" className="flex items-center gap-2 text-xl font-bold text-blue-400">
//             <span className="w-2 h-2 rounded-full bg-blue-400 inline-block" />
//             MAILORA
//           </Link>
//           <div className="flex gap-3">
//             <Link to="/login" className="px-4 py-2 rounded-xl text-blue-100 hover:bg-white/10 transition">
//               Войти
//             </Link>
//             <Link to="/register" className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-500 transition shadow-md">
//               Регистрация
//             </Link>
//           </div>
//         </div>
//       </header>

//       <section ref={sceneRef} className="relative" style={{ height: '200vh' }}>
//         <div className="sticky top-0 h-screen overflow-hidden">
//           <div
//             className="absolute -left-40 top-10 w-[520px] h-[520px] rounded-full bg-blue-600/25 blur-[120px]"
//             style={{ transform: `translateY(${p * -260}px)` }}
//           />
//           <div
//             className="absolute -right-32 bottom-0 w-[460px] h-[460px] rounded-full bg-indigo-500/20 blur-[120px]"
//             style={{ transform: `translateY(${p * 320}px)` }}
//           />

//           <div
//             className="absolute inset-x-0 top-[13vh] px-4 text-center z-10"
//             style={{ opacity: heroOpacity, transform: `translateY(${p * -160}px)` }}
//           >
//             <span className="inline-block text-xs font-semibold tracking-wider uppercase text-blue-300 bg-blue-500/15 px-3 py-1 rounded-full mb-5">
//               Мы запустились!
//             </span>
//             <h1 className="text-4xl md:text-6xl font-bold leading-tight">Сервис для email рассылок</h1>
//             <p className="mt-4 text-base md:text-lg text-blue-100/70 max-w-[56ch] mx-auto">
//               Привлекайте новых клиентов в B2B сегменте с помощью деловой коммуникации через email переписки.
//             </p>
//             <Link
//               to="/register"
//               className="inline-block mt-7 px-6 py-3 rounded-xl bg-blue-600 text-white font-medium hover:bg-blue-500 transition shadow-lg"
//             >
//               Попробовать бесплатно 7 дней
//             </Link>
//           </div>

//           <div
//             className="absolute inset-x-0 top-[10vh] text-center px-4 z-10 pointer-events-none"
//             style={{ opacity: cap2 }}
//           >
//             <h2 className="text-2xl md:text-4xl font-bold">Одно нажатие — и код оживает</h2>
//           </div>
//           <div
//             className="absolute inset-x-0 top-[10vh] text-center px-4 z-10"
//             style={{ opacity: cap3 }}
//           >
//             <h2 className="text-2xl md:text-4xl font-bold">Сотни писем ушли, пока вы пили кофе</h2>
//             <Link
//               to="/register"
//               className="inline-block mt-5 px-6 py-3 rounded-xl bg-blue-600 text-white font-medium hover:bg-blue-500 transition shadow-lg"
//             >
//               Попробовать бесплатно 7 дней
//             </Link>
//           </div>

//           <div
//             className="absolute inset-x-0 bottom-0 z-0"
//             style={{
//               transform: `translateY(${y}px)`,
//               perspective: '1600px',
//             }}
//           >
//             <div style={{ transform: `rotateX(${tilt}deg) scale(${scale})`, transformOrigin: '50% 100%' }}>
//               <MacBook p={p} pRef={pRef} />
//             </div>
//           </div>
//         </div>
//       </section>

//       <Features />

//       <footer id="footer" className="bg-white text-gray-900 border-t border-gray-200 py-10">
//         <div className="max-w-6xl mx-auto px-4">
//           <div className="text-[13px] leading-relaxed text-gray-500 font-light">
//             <div className="flex flex-wrap gap-x-6 gap-y-1">
//               <span><span className="text-gray-400">ИП</span> Сидоренко Руслан Владимирович</span>
//               <span><span className="text-gray-400">ИНН</span> 611300126009</span>
//               <span><span className="text-gray-400">ОГРНИП</span> 317619600088799</span>
//             </div>
//           </div>
//           <div className="border-t border-gray-200 mt-6 pt-6 text-[13px] text-gray-500 font-light">
//             © {new Date().getFullYear()} Mailora. Все права защищены.
//           </div>
//         </div>
//       </footer>

//       <CookieBanner />
//     </div>
//   );
// }